import * as THREE from "three";
import { defaultInsulationValues } from "../../../Constants/constant";
import { getCRMSettings } from "../../../crmSettingsAdapter";
export const params = {
	added_building_bracing: {
		p_e_c_b_l: false, // left gable end bracing
		p_s_c_b_l: false, // left gable side bracing
		p_e_c_b_r: false, // right gable end bracing
		p_s_c_b_r: false, // right gable side bracing
		p_e_c_b_f: false, // front gable end bracing
		p_s_c_b_f: false, // front gable side bracing
		p_e_c_b_b: false, // back gable end bracing
		p_s_c_b_b: false // back gable side bracing
	},
	addGableLeanToggleVisibility: false,
	old_params: {},
	doorNames: {
		17: "Frameout",
		180: "Opening/Header"
	},
	wallOrientation: "horizontal", // horizontal/vertical/blank
	company_id: "",
	p_c_i: false,
	l_t_p: JSON.parse(JSON.stringify(defaultInsulationValues)),
	apiCallAfterEdit: false,
	selectedState: "",
	selectedManufacture: "",
	selectedManufactureId: "",
	leanStyle: { left: "standard", right: "standard", front: "standard", back: "standard" },
	freeStandingSide: "left",
	logoWidth: 3800 / 1000 / 20,
	logoHeight: 2200 / 1000 / 20,
	insulation: {
		center: { showInsulation: false, isCheked: false, insulationId: 0, roofOnly: false, fullBuilding: false, showInsulationOptions: false, isDisableFullInsulation: false, custom: false },
		frontLean: { showInsulation: false, isCheked: false, insulationId: 0, roofOnly: false, fullBuilding: false, showInsulationOptions: false, isDisableFullInsulation: false, custom: false },
		leftLean: { showInsulation: false, isCheked: false, insulationId: 0, roofOnly: false, fullBuilding: false, showInsulationOptions: false, isDisableFullInsulation: false, custom: false },
		rightLean: { showInsulation: false, isCheked: false, insulationId: 0, roofOnly: false, fullBuilding: false, showInsulationOptions: false, isDisableFullInsulation: false, custom: false },
		backLean: { showInsulation: false, isCheked: false, insulationId: 0, roofOnly: false, fullBuilding: false, showInsulationOptions: false, isDisableFullInsulation: false, custom: false }
	},
	preAction: {},
	toggleBuildingStyleChange: false,
	isBuildingStyleChange: false,
	selectedInsulationId: 0,
	isBuildingStyleChange: false,
	isDefaultfourFeet: false,
	canopy: false,
	cupola: false,
	cupolaQty: 1,
	cupolasize: "",
	newtrussType: "",
	c_r_c: "0xffffff",
	c_r_c_name: "White",
	c_r_c_id: "White",
	isWallCheck: "Open",
	oncenter_val: 0,
	oncenter_val_with_action: "",
	lift_type: false,
	lifttype_price: 0,
	lifttype_name: "",
	params_cancel: {},
	trimVal: -2,
	alignL: "1",
	alignR: "1",
	alignB: "1",
	alignF: "1",
	activeWall: "c_b_f_w",
	isSnowLoad: false,
	is_showCenter: false,
	is_translusant: false,
	isDoorOverlap: false,
	isShowCenter: false,
	singleSlope: false,
	p_l_w_center: false,
	dropdown_flagF: false,
	dropdown_flagB: false,
	paymentmode: "cash",
	p_f_wF: "Open",
	p_b_wB: "Open",
	p_w: 12,
	p_d: 21,
	p_h: 8,
	p_r_t: "Gabled",
	p_a_s: 0,
	p_r_p: 3,
	p_s_m: "Steel",
	p_r_c: "0xAE8F66",
	p_w_c: "0xAE8F66",
	p_t_c: "0xffffff",
	p_s_c: "Gray",
	p_w_c_c: "0x124B8A",
	p_w_c_n: false,
	p_w_c_n_j_trim: true,
	p_w_s1: false,
	p_w_s2: false,
	p_w_s3: false,
	p_w_s4: false,
	p_g_f: 0,
	building_type_name: "",
	other_building_type_name: "",
	checkeditName: false,
	p_g_b: 0,
	p_e: 0,
	p_e_p_l: 2,
	p_e_s_l: false,
	p_e_r: 0,
	p_e_p_r: 2,
	p_e_s_r: false,
	p_c_2: false,
	p_c_3: false,
	additional_note: "",
	p_b_t: 1,
	manageSideLean: "left",
	p_r_s: "3",
	p_b_c: "Open",
	p_b_c_b: "Open",
	p_v_w: false,
	wallTexture: "none",
	wainscotTexture: "none",
	p_e_i: "",
	p_e_i_other: "",
	gauge_val: "",
	gauge_val_check: false,
	fourth_center_cost: false,
	risk_cost: false,
	cert_pac_cost: false,
	p_b: "0",
	p_i_s: "1",
	p_e_l: false,
	lean_p_e_l: false,
	leanF_p_e_l: false,
	leanR_p_e_l: false,
	leanB_p_e_l: false,
	p_t_u: 0,
	p_f_w: "Open",
	p_c_p_l: false,
	p_c_p_r: false,
	p_c_p_f: false,
	p_c_p_b: false,
	p_b_w: "Open",
	p_l_w: "Open",
	p_r_w: "Open",
	p_r_w_S_S_L: "Open",
	is_trasparent: false,
	p_c_a_w: false,
	p_c_a_f_l_w: false,
	p_c_a_b_l_w: false,
	p_c_a_l_l_w: false,
	p_c_a_r_l_w: false,
	p_l_w_p: 0,
	p_r_w_p: 0,
	p_j_t: false,
	p_j_t_end: false,
	p_e_b: 0,
	p_e_t: 0,
	p_b_p: false,
	p_b_p_feet: "Select",
	p_b_p_feetVal: "0",
	p_i_o: "0",
	p_a_ch: 0,
	p_a_ch_w_B: 0,
	p_b_c_b_l_f: "Open",
	p_b_c_b_l_b: "Open",
	p_b_c_b_l: "Open",
	p_b_c_b_l_r: "Open",
	p_b_c_b_f_f: "Open",
	p_b_c_b_f_b: "Open",
	p_b_c_b_f_l: "Open",
	p_b_c_b_f_r: "Open",
	p_b_c_b_b_b: "Open",
	p_b_c_b_b_f: "Open",
	p_b_c_b_b_l: "Open",
	p_b_c_b_b_r: "Open",
	p_b_c_b_r_f: "Open",
	p_b_c_b_r_b: "Open",
	p_b_c_b_r: "Open",
	p_b_c_b_r_r: "Open",
	w_a_s_tTYP: 0,
	w_a_s_tTYP_OPT_S: 0,
	w_a_s_tTYP_OPT_E: 0,
	p_u_t: 10,
	p_u_c: false,
	p_f_b_l: true,
	p_l_b_l: true,
	p_r_b_l: true,
	p_b_b_l: true,
	p_m_h_a: 0,
	p_r_a: 0,
	p_f_i: false,
	p_r_o: false,
	p_s_i: "",
	p_s_n: "",
	m_s_n: "",
	p_g_i: "",
	truck: false,
	orignalName: "",
	truckPOS: "0,0,0",
	truckROT: "0,0,0",
	driveway: false,
	drivewayPOS: "0,0,0",
	drivewayROT: "0,0,0",
	p_v: 0.21,
	dpSelectComponentValue: "Select",
	wallPos: "Select",
	p_a_g_r_u_d: "Select",
	p_a_g_r_u_d_c_s: "Select",
	p_a_g_r_u_d_c_s1: "Select",
	f_r_m_o_t: "Select",
	f_r_m_o_t1: "Select",
	p_d_c: "Select",
	doorSize: "Select",
	doorType: "Garage",
	doorLabel: "",
	trimkit: false,
	chain_hoist: false,
	header_seal: false,
	certified_door: false,
	automatic_openers: false,
	insulated: false,
	threshold: false,
	extra_notes: "",
	p_w_cc: "Select",
	l_l_to: "Open",
	r_l_to: "Open",
	b_r_p: "3",
	p_r_c_name: "Red",
	p_w_c_name: "Red",
	p_t_c_name: "Red",
	p_w_c_c_name: "Red",
	p_r_c_id: "Red",
	p_w_c_id: "Red",
	p_t_c_id: "Red",
	p_w_c_c_id: "Red",
	p_u_f_w: "Close",
	b_l_t_r_pF: "2",
	b_l_t_r_pB: "2",
	b_l_t_r_p: "2",
	b_l_t_r_pR: "2",
	p_b_l_t_r_p_f: "3",
	p_b_l_t_r_p_b: "3",
	p_b_l_t_r_p: "3",
	p_b_l_t_r_p_r: "3",
	b_l_t_r_p_r: "3",
	b_l_t_r_p_f: "3",
	b_l_t_r_p_b: "3",
	b_r_p: "3",
	b_l_t_s: "",
	p_f_w_f: "Open",
	b_f_l_t_f: "Open",
	b_f_l_t_r: "Open",
	b_f_l_t_l: "Open",
	b_b_l_t_f: "Open",
	b_b_l_t_r: "Open",
	b_b_l_t_l: "Open",
	b_l_l_t_f: "Open",
	b_l_l_t_b: "Open",
	b_l_l_t_l: "Open",
	b_l_l_t_r: "Open",
	b_r_l_t_f: "Open",
	b_r_l_t_b: "Open",
	b_r_l_t_r: "Open",
	b_r_l_t_l: "Open",
	b_w_r_p: "",
	b_r_s: false,
	leantoHeight: 0,
	DoorPosOnEdit: "",
	DoorLocOnEdit: "",
	UpdatedDoorPosOnEdit: "",
	DoorRotOnEdit: "",
	isDefault_r_p: "4",
	isDefault_l_t_r_p: "3",
	cd: 0,
	b_w_p: "",
	scrUP: false,
	scrDW: false,
	add_front_lean: false,
	add_back_lean: false,
	add_left_lean: false,
	add_right_lean: false,
	leanF_p_w: 12,
	leanF_p_d: 12,
	leanF_p_h: 6,
	leanF_p_pos: 0,
	leanB_p_w: 12,
	leanB_p_d: 12,
	leanB_p_h: 6,
	leanB_p_pos: 0,
	lean_p_w: 12,
	lean_p_d: 21,
	lean_p_h: 6,
	lean_p_pos: 0,
	leanR_p_w: 12,
	leanR_p_d: 21,
	leanR_p_h: 6,
	leanR_p_pos: 0,
	continous_front_lean: false,
	continous_back_lean: false,
	continous_left_lean: false,
	continous_right_lean: false,
	add_storage: 5,
	add_storage_check: false,
	cB_addStorage_front: 10,
	cB_addStorage_check_front: false,
	isBreezeway: false,
	nostorage: true,
	noStorageCertificatePriceChange: false,
	cB_addStorage_check_right: false,
	cB_addStorage_check_right_utility: false,
	cB_addStorage_check_left_utility: false,
	cB_addStorage_right_utility: 5,
	cB_addStorage_left_utility: 5,
	cB_addStorage_check_left: false,
	cB_addStorage_check_both: false,
	cB_addStorage_check_both_with_back: false,
	add_storage_check_front: false,
	add_storage_check_back: false,
	cB_addStorage_right: 10,
	cB_addStorage_left: 10,
	add_storage_right: 5,
	add_storage_front: 5,
	add_storage_back: 5,
	add_storage_check_right: false,
	add_storage_check_1: false,
	add_storage_check_right_1: false,
	add_storage_check_front_1: false,
	add_storage_check_back_1: false,
	add_right_front_porch: false,
	add_right_back_porch: false,
	add_left_front_porch: false,
	add_left_back_porch: false,
	add_wrap_around_porch: false,
	add_left_front_lean_porch: false,
	add_right_front_lean_porch: false,
	add_right_back_lean_porch: false,
	add_left_back_lean_porch: false,
	r_f_p_w: 5,
	r_f_p_d: 5,
	r_b_p_w: 5,
	r_b_p_d: 5,
	l_f_p_w: 5,
	l_f_p_d: 5,
	l_b_p_w: 5,
	l_b_p_d: 5,
	cmrpos: false,
	leftstorage: false,
	rightstorage: false,
	centerstorage: false,
	leantoAlignmentFront: 1,
	leantoAlignmentLeft: 1,
	leantoAlignmentRight: 1,
	leantoAlignmentBack: 1,
	oldPosleantoAlignmentLeft: 1,
	oldPosleantoAlignmentRight: 1,
	endStoragePositionZ: 0,
	leftLeanStoragePosition: 0,
	rightLeanStoragePosition: 0,
	frontLeanStoragePosition: 0,
	backLeanStoragePosition: 0,
	p_g_c: false,
	o_v_h_n_g: false,
	o_v_h_n_g_e: false,
	p_o_p: false,
	p_p_b: 0,
	a_c_p_l: false,
	a_c_p_r: false,
	a_c_p_f: false,
	a_c_p_b: false,
	p_s_c_b: false,
	p_e_c_b: false,
	leanF_p_e_i: "0",
	leanB_p_e_i: "0",
	lean_p_e_i: "0",
	leanR_p_e_i: "0",
	leanF_p_e_i_other: "",
	leanB_p_e_i_other: "",
	lean_p_e_i_other: "",
	leanR_p_e_i_other: "",
	tax_exempt: false,
	tax_zipcode: "",
	ShowLeanRecord: false,
	customW: "6",
	customH: "6",
	job_site_level: "yes",
	power_avail: "yes",
	chkFrameOpening: false,
	display_product_status: "in_stock",
	globalTaxValue: "sales_tax",
	g_d_c: "0xffffff",
	g_d_c_name: "White",
	g_d_c_id: "White",
	frame_length: 0,
	m_s_n_1: 0,
	m_s_n_2: 0,
	m_n_f_1: "Select",
	m_n_f_2: "Select",
	g_d_c_Obj: {
		blue_value: 255,
		cost: 0,
		cost_type: 0,
		green_value: 255,
		hex_value: "#ffffff",
		id: -1,
		manufacturer_id: 8,
		name: "White",
		percentage_of_cost: 0,
		red_value: 255
	}
};
export const const_var = {
	leanto_roof_pitch_obj: {},
	isInsulationPriceManualChange: false,
	is_intel: false,
	is_intel_edit: false,
	new_selected_default_building_id: "",
	default_building_id: "",
	default_manufacturer_id: "",
	default_price_book_id: "",
	default_user_id: "",
	selectedDefaultIndex: 1,
	default_Image_object: {},
	NewTrussOption: [],
	default_building_data: {},
	leadCreatedSuccessfully: false,
	edit_utility: false,
	selLoftVal: {
		center: 4,
		left: 4,
		right: 4,
		front: 4,
		back: 4
	},
	loft_value_array: {
		center: [],
		left: [],
		right: [],
		front: [],
		back: []
	},
	extraAddOnItemsArrayList: { left: [], right: [], front: [], back: [] }, // used for lean to only
	extraAddOnItemsArrayCompare: [],
	callFromDoorAddOrRemove: false,
	is_edit_extra_labour: false,
	holdTaxArrResp: [],
	isWainscotManualPriceUpdate: false,
	thirdPartyPricesObj: {},
	newThirdPartySurcharge: {},
	thirdPartyComponent: {
		commissions: {
			insulation: {
				center: {},
				left: {},
				right: {},
				front: {},
				back: {}
			},
			garage: {}
		},
		surcharge: {
			insulation: {
				center: {},
				left: {},
				right: {},
				front: {},
				back: {}
			},
			garage: {}
		},
		tax: {
			insulation: {},
			garage: {}
		}
	},
	isPublicUrlNonEditable: false,
	LNTCrossBracing: { left: [], right: [], front: [], back: [] },
	selected_scbracing: "",
	selected_ecbracing: "",
	selectedBracingForAddedBuilding: {
		left_lean_end: "",
		left_lean_side: "",
		right_lean_end: "",
		right_lean_side: "",
		front_lean_end: "",
		front_lean_side: "",
		back_lean_end: "",
		back_lean_side: ""
	},
	isCompanyIdChanged: false,
	stateColorAcordingAPI: {},
	isFromSalesLogin: false,
	isCompanyChangedInEdit: false,
	companyIdSelectedFromStateScreen: "",
	old_const_var: {},
	isManufacturerForLeantoClearance: true,
	manufacturerForLeantoClearance: 3,
	isStorageMovementEnable: false,
	isLTEnable: false,
	isStorageMovementEnableForMfg: false,
	isLTEnableForMfg: false,
	cbInsulation: [],
	isLNTBuildingIsCustom: false,
	onDragUtilityPriceUpdateCenterBuilding: false,
	wainscot_filter_data: [],
	stateManufactureDataFromApi: [],
	onDragUtilityPriceUpdateLeft: false,
	onDragUtilityPriceUpdateRight: false,
	onDragUtilityPriceUpdateFront: false,
	onDragUtilityPriceUpdateBack: false,
	old_const_var: {},
	c_f_aCerLean: { left: [], right: [], front: [], back: [] },
	lNTBuildingData: {
		additionalFeaturesArray: { centerBuilding: [], left: [], right: [], front: [], back: [] },
		ExtraItemsFeaturesArray: { centerBuilding: [], left: [], right: [], front: [], back: [] },
		extraAddOnItemsArray: { centerBuilding: [], left: [], right: [], front: [], back: [] }, // for added building
		ExtraItemsFeaturesArrayForOverhangComputation: { centerBuilding: [], left: [], right: [], front: [], back: [] },
		ExtraItemsFeaturesQuantityArray: { centerBuilding: [], left: [], right: [], front: [], back: [] },
		certificate: { centerBuilding: [], left: [], right: [], front: [], back: [] },
		updatePriceDataElements: { centerBuilding: {}, left: {}, right: {}, front: {}, back: {} }
	},
	isCBSelected: true,
	selectedLeanType: "", // "" | 'left' | 'right' | 'front' | 'back
	isLTBuilding: false,
	requestApiToken: "",
	isUpdate4ftLegLogic: false,
	old_const_var: {},
	wainscotApiCall: "",
	wainscot_metal: {
		horizontal_cost: 0,
		label: "Metal",
		name: "metal",
		panel_orientation: ["horizontal", "vertical"],
		panel_price_from: [],
		price_of: [],
		price_type: "$",
		vertical_cost: 0
	},
	userCompanies: [],
	discount_info: null,
	customSizeStatus: {
		show_garage_door: null,
		show_garage_door_frameout: null,
		show_walk_in_door: null,
		show_walk_in_door_frameout: null,
		show_window: null,
		show_window_frameout: null
	},
	updated_engineer_drawings_price: 0,
	engineer_drawings_price_changed: true,
	hightCategory: "slant_height",
	mainSidingOptions: [
		{
			name: "metal",
			label: "Metal",
			price_type: "$",
			price_of: [],
			panel_price_from: ["vertical"],
			panel_orientation: ["horizontal", "vertical"],
			cost: 0
		}
	],
	compareMainSidingOptions: [
		{
			name: "metal",
			label: "Metal",
			price_type: "$",
			price_of: [],
			panel_price_from: ["vertical"],
			panel_orientation: ["horizontal", "vertical"],
			cost: 0
		}
	],
	compareSelSidingObj: {
		name: "metal",
		label: "Metal",
		price_type: "$",
		price_of: [],
		panel_price_from: ["vertical"],
		panel_orientation: ["horizontal", "vertical"],
		cost: 0
	},
	selSidingOption: "metal",
	selSidingObj: {
		name: "metal",
		label: "Metal",
		price_type: "$",
		price_of: [],
		cost: 0,
		panel_price_from: ["vertical"],
		panel_orientation: ["horizontal", "vertical"]
	},
	sidingOptions: [],
	sidingOrientationOptions: [
		{ value: "horizontal", label: "Horizontal" },
		{ value: "vertical", label: "Vertical" }
	],
	isUtilityLengthChange: false,
	isUtilityChanges: false,
	isManualCapture: false,
	installationsurfaceChange: true,
	installation_surface: 1,
	holdDefaultBuildingArr: {},
	isRoofPitchChangedManually: false,
	otherBuildingRoofPitch: "",
	showDiscountBanner: false,
	stripe: { checkout_key: "", checkout_type: "" },
	eventKey: "",
	isMobileDraw: false,
	leanToLegPosObj: { front: [0], back: [0], right: [0], left: [0] },
	diffHeight: "",
	changeMfgLblEnable: false,
	selectedDicountOfferobj: {},
	showAppliedButton: false,
	showActiveButton: false,
	manually_edited_mgf_lbl: false,
	checkApplyButtonClick: false,
	showOutOfRange: false,
	checkLimit: false,
	manufacturer_discount_changed: false,
	edited_manufacturer_discount_label: "",
	offer_applied_name: "",
	offerId: "",
	discount_Offers_end_date: "",
	freeDrawing: false,
	zipErrDefaultMessage: "",
	showStateBoxInZipErr: false,
	showStateBoxInZipDefault: false,
	state_mfg_zipcode_old: "",
	zipcodeToolTipDataFlag: false,
	zipcodeToolTipData: {},
	isGlobalZipUpdate: false,
	zipErrorMsgFlag: false,
	showStateFieldInToolTip: false,
	isFreeStandingBuilding: false,
	insulationJsonLeanTo: [],
	compareInsId: 0,
	insulationJsonCompare: {},
	wallNameArray: {
		p_f_w: "front",
		p_b_w: "back",
		p_l_w: "left",
		p_r_w: "right",
		p_b_c_b_f_f: "front",
		p_b_c_b_f_b: "back",
		p_b_c_b_f_l: "side",
		p_b_c_b_l_f: "front",
		p_b_c_b_l_b: "back",
		p_b_c_b_l: "side",
		p_b_c_b_r_f: "front",
		p_b_c_b_r_b: "back",
		p_b_c_b_r: "side",
		p_b_c_b_b_f: "front",
		p_b_c_b_b_b: "back",
		p_b_c_b_b_l: "side",
		storage_back: "storage back",
		storage_front: "storage front",
		storage_left: "storage left",
		storage_right: "storage right",
		storage_roof: "storage roof",
		open_roof: "open roof",
		full_roof: "full roof"
	},
	CompareCBInsulationPrice: 0,
	CompareFLInsulationPrice: 0,
	CompareBLInsulationPrice: 0,
	CompareLLInsulationPrice: 0,
	CompareRLInsulationPrice: 0,
	CBInsulationPrice: 0,
	FLInsulationPrice: 0,
	BLInsulationPrice: 0,
	LLInsulationPrice: 0,
	RLInsulationPrice: 0,
	InsulationOnWall: {},
	InsulationObj: [],
	skyIMG: "",
	groundIMG: "",
	envIMG: "",
	textureGrass: "",
	textureGray: "",
	TrimTexture: "",
	metalTexture: "",
	wallTextureObj: { vertical: undefined, lap_siding: undefined, board_and_batten_siding: undefined, none: undefined },
	loadGltObj: "",
	stateManufactureChangeId: "",
	stateManufactureFlag: "",
	is_price_edit: false,
	isForStandardBuilding: false,
	isFeedbackFieldMandatory: false,
	navEventKey: { leanto: "leftLean", walls: "0" },
	showProfileModal: false,
	additionalChargeArr: [],
	showComparePrices: true,
	regionId: [],
	commonBuildingFlag: {
		center: { buildingHeight: false },
		leftLean: { leftLeanHeight: false },
		rightLean: { rightLeanHeight: false },
		frontLean: { frontLeanHeight: false },
		backLean: { backLeanHeight: false },
		wrap: false,
		premiumcolor: false
	},
	wallSelection: {
		centerBuildingWall: "c_b_f_w",
		leanToWall: "select"
	},
	componentNameForAlert: "",
	activeTab: null,
	popularSizeArray: [],
	oldPriceForColorCost: 0,
	colorPrice: {
		roof_color_price_changed: false,
		wall_color_price_changed: false,
		trim_color_price_changed: false,
		wainscot_color_price_changed: false
	},
	setSidesEndsWallOption: "open",
	setLeanWallOption: { frontLean: "open", backLean: "open", rightLean: "open", leftLean: "open" },
	reinforcedtype: { center: "single", left: "single", right: "single", front: "single", back: "single" },

	/****************  Giorgi  **********************/
	componentDistance: 1,
	roofRegularDst: 0.5,
	/****************  Giorgi  **********************/

	focusedSection: "",
	isDataWithlegCut: false,
	legCutFlag: true,
	mutipleSizesBuilding: false,
	isFromStateChange: false,
	checkmoreCustomizeFlag: false,
	isMultiSelectDrawingOpt: true,
	is_custom_building: false,
	dealer_discount_label: "",
	manufacturer_discount_label: "",
	exact_order_permit_fee: 0,
	isFromCompare: false,
	isFromCompareForCompChk: false,
	isFromPickThis: false,
	Overhang: {},
	isOverhang: {
		end: {
			isChecked: false,
			selected: "",
			size: 0.5
		},
		side: {
			isChecked: false,
			selected: "",
			size: 0.5
		},
		both: {
			isChecked: false,
			selected: "",
			size: 0.5
		}
	},
	isLayoutDesign: false,
	resetpasswordcrm: true,
	fromGetBuildingData: false,
	fromChangeDimension: false,
	zipManufErrMsg: "",
	is_State_Edit: false,
	showStateZip: false,
	isZipcodeIncluded: true,
	state_mfg_zipcode: "",
	tempZCode: "",
	resetVal: false,
	isTBSOldQuotesForVerticalRoof: false,
	isShowUpdatedBuildingImages: ["carport1.com", "americanmetalbuildings.com", "aametalbuildings.com", "safeguardmetalbuildings.com", "steelbuildingsandstructures.com", "eaglebuildings.com"],
	changeComponentSize: false,
	isKLinkEnable: false,
	KLinkDataUpdate: false,
	SApiCalled: false,
	showInfoError: false,
	showStateOnly: false,
	apiCalledforState: false,
	showStateField: false,
	MFApiCalled: false,
	tempPostData: {},
	saveLatterModal: false,
	createLeadOnly: false,
	preQuoteApiCalled: false,
	preQuoteError: false,
	zipCode: "",
	ziperrormsg: "",
	showReportLoading: false,
	reportDesc: "",
	reportIssueID: "",
	showReportIssueModal: false,
	errormsg: "",
	setScreenshot: "",
	ticketId: "",
	duplicateTaxZipCode: "",
	TempLeadCustomerData: "",
	isSetZip: false,
	isTripleWide: false,
	isSingleBaseRail: false,
	singleBaseRailByMnf: [34, 58, 73],
	wallNameColor: "aqua",
	checkPanelForLean: { left: false, right: false },
	isInsulaltionForOldQuotes: false,
	isOpenMeeting: false,
	isOpenUserTour: false,
	startTourNumber: "",
	currentStepTour: 1,
	selectWaterMarkByMNF: {
		"7KJeHld8lthhZRr0qzJEjYfnbjmXhXiKSGa73bv1XqENGNIthoKdbT4gIznBTV7i": "martinezcarportsllc",
		"7oVN03loA8TrK6y1igOxmmdJ1D9OCew5MB8W97YetSLVNpzXgOgXUPrcPVH3kYYh": "building4Less",
		IGMWikT6PT82EHlYmEAMzQ6POIfNI7uWbQXxpRM3lOKu9OvVBYaZ5Jto4Msu7CM8: "bullbuildings",
		TQ4cpaVBiUhiX1nqR4THXreYThhailXckCQ25pAJsXY4b8QVQ4ISPrpiCPvpUg8g: "riversidemetalstructures",
		r3VDel5LeO4uY020FAYZ99zhNO8zBfHXP5tiIBhXZxdVuggT2jDmeQNHlIOFdzAg: "pacificbuildingsinc",
		Fq6Meq4bloS4c7Pqj7OuVNHfiPhWnuesTwy3KiuFNCJ2cyu3WKIGEFqc74qsprei: "steelbuildingsandstructures",
		Bqxq40K4zojI9VBP630isdq7GqlmZOV4oWhnHC5eanGpV7iOacGP9Gba6D9slWTG: "eaglebuildings",
		GuEssZt4YAZi5ot69xbO9I4w3dbxgPJNXsUFCJJPevH3zt1ONTUabif5hRKJ41Oc: "rhinometalstructures",
		X9J7WuONkgZck41DEkbhi9r6HIkwypqpMnH1HoXx57LrvuCxtX7gLKFeDnQlrSfc: "anchoragesteelbuildings",
		xhkZaSoQHjhlFHCOQgesOnsy7o1juN0tkg8wMfk8JAVljzl4XdPsPj5AzlDeZnoT: "americanmetalbuildings",
		j71D6wqYltk69UVs9lw4UFiVhRQC1kevjFNI6yHWxGI9Mpz1C0Tbl1wJrWdlarZ2: "aametalbuildings",
		P7jxFfksz6Caf8pfuWSaaAUbg86JLeelGnVZgAwugjI0ayK35I9Olh0V5wMgKpvQ: "carport1",
		P0pjF0vzahFWP8DTFzQulTkOFi5b2cpoeNrLSxIMXxgMRe0fpAYKRpFRLCPvC9ke: "safeguardmetalbuildings",
		iIzTnlBDIJSwr1zqFpZ6u7iPnEwL12EjfgZ0JpminlR2N6byb3P1XsXeu95QoeRD: "custombuiltstructures",
		mflMO6hnObaoNO7Z8oPLP6HScYnTg5QARdj7lq8dICqGgEcCWX11Uprgq35aMIo3: "samsonsteelstructures",
		tqRONV664tLp1rKbyF7Lqjs0rG5ngbvdhyzvCJ9FAQ6Vfe00DArmnVfL5ZGAPspv: "ultimatebuildingsolution"
	},
	centerGroundWaterMark: [
		,
		"pacificbuildingsinc",
		"us-steelbuilding",
		"allsteelstructure",
		"universalbuildingsllc",
		"riversidemetalstructures",
		"bullbuildings",
		"aametalbuildings",
		"steelbuildingsandstructures",
		"eaglebuildings"
	],
	showNonLoginWaterMark: [
		"pacificbuildingsinc.com",
		"complexsteelbuildings.com",
		"us-steelbuilding.com",
		"jvmetalbuildingsllc.com",
		"allsteelstructure.com",
		"universalbuildingsllc.com",
		"riversidemetalstructures.com",
		"bullbuildings.com",
		"aametalbuildings.com",
		"steelbuildingsandstructures.com",
		"eaglebuildings.com",
		"rhinometalstructures.net",
		"anchoragesteelbuildings.com",
		"americanmetalbuildings.com",
		"carport1.com",
		"safeguardmetalbuildings.com",
		"custombuiltstructures.com",
		"samsonsteelstructures.com",
		"ultimatebuildingsolution.com",
		"bestwaybarns.com"
	],
	breezewayLength: 10,
	breezewayFrontStorageOptions: [],
	breezewayBackStorageOptions: [],
	breezewayFrameoutOptions: [],
	count_numberofLegs: 0,
	referralID: "",
	alertPubliMessage: "",
	alertExpireMessage: "",
	isPublicModuleID: "",
	isPublicEdit: false,
	noCursorClass: false,
	is_loader: false,
	ScrollCaptureEnd: true,
	surcharge_amount_is_edit: false,
	isCheckDisabled: false,
	cupolaForMove: [],
	cupola: "",
	cupolaCount: 0,
	cupolaUniqueId: 1,
	dragCupola: false,
	cupolas: [],
	cupolaEntries: [],
	cupolasData: [],
	cupolaPosition: {},
	isCupolaAdded: false,
	isheilightCupola: false,
	previousCupolaZpositionOnMove: 0,
	cupolaType: "without_windows",
	wallsData: { center: {}, leftLean: {}, rightLean: {}, frontLean: {}, backLean: {} },
	lengthData: {
		center: { length: 0, legsCount: 0, previousLength: 0, porchLength: 0 },
		leftLean: { length: 0, legsCount: 0, previousLength: 0, porchLength: 0 },
		rightLean: { length: 0, legsCount: 0, previousLength: 0, porchLength: 0 },
		frontLean: { length: 0, legsCount: 0, previousLength: 0, porchLength: 0 },
		backLean: { length: 0, legsCount: 0, previousLength: 0, porchLength: 0 }
	},
	cbClosedSideWalls: 0,
	cbClosedEndWalls: 0,
	cbFullyEnclosedWalls: 0,
	flFullyEnclosedWalls: 0,
	blFullyEnclosedWalls: 0,
	llFullyEnclosedWalls: 0,
	rlFullyEnclosedWalls: 0,
	flClosedSideWalls: 0,
	flClosedEndWalls: 0,
	llClosedSideWalls: 0,
	llClosedEndWalls: 0,
	rlClosedSideWalls: 0,
	rlClosedEndWalls: 0,
	blClosedSideWalls: 0,
	blClosedEndWalls: 0,
	frontLeanLegs: 0,
	leftLeanLegs: 0,
	rightLeanLegs: 0,
	backLeanLegs: 0,
	checkPickThisBuilding: false,
	isBreezewayPickThisBuilding: false,
	compareMainBuildingPriceRes: "",
	ShowTwodLayoutDefault: false,
	hodldEditBuildingData: {},
	checkDoorIsadded: false,
	leanHeight: 0,
	checkForCutPannel: 0,
	checkVerticalCheckBox: false,
	paymentOptionObj: {
		finance: { type: "financing", finance_company: "", application_id: "", plan_no: "" },
		cash: { type: "cash", finance_company: "", application_id: "", plan_no: "" },
		rto: { type: "rent_to_own", finance_company: "", application_id: "", plan_no: "" },
		certified_check: { type: "certified_check", finance_company: "", application_id: "", plan_no: "" },
		money_order: { type: "money_order", finance_company: "", application_id: "", plan_no: "" },
		cod: { type: "cash_on_delivery", finance_company: "", application_id: "", plan_no: "" }
	},
	getPaymentValue: { financing: "finance", rent_to_own: "rto", cash: "cash", certified_check: "certified_check", money_order: "money_order", cash_on_delivery: "cod" },
	showDisabledClass: false,
	porch: {},
	leanto_condition_by_mfg: {},
	compare_leanto_condition_by_mfg: { side_lean_to: 1, end_lean_to: 0, wrap_around: 0 },
	leadSourceStateData: {},
	leanDimension: {},
	mainLeantoValue: { 1: "Left", 2: "Right", 3: "Front", 4: "Back" },
	newRaycaster: new THREE.Raycaster(),
	newMouse: new THREE.Vector2(),
	newIntersects: "",
	normalMatrix: new THREE.Matrix3(),
	worldNormal: new THREE.Vector3(),
	lookAtVector: new THREE.Vector3(),
	dragging: false,
	newDoorsArray: [],
	notMovableDoors: [],
	wallArray: { front: {}, back: {} },
	user_type_for_comparision: "standard",
	checkUserRole: [],
	showhideUpgradePlan: "",
	jtrimCustomArray: false,
	ComparisionDataArray: {},
	NoCompareData1: false,
	NoCompareData2: false,
	showCompareMnfList_1: false,
	showCompareMnfList_2: false,
	comparisionLoadermfg1: false,
	comparisionLoadermfg2: false,
	comparisionLeantoloader: false,
	chknewCount: 0,
	isShowEditConfigurationButton: false,
	defaultBuildingColorArray: [],
	checkSurchangeData: false,
	checkforLeanto: false,
	checkForLeantoLegs: false,
	SendAPIBuildingData: {},
	isShowEmageEditor: false,
	PrintAlertBoxShowButton: false,
	PrintAlertBox: false,
	SharingAlertBox: false,
	showGaugePrice: false,
	showGaugePriceVal: 0,
	showTrussPriceVal: 0,
	two_d_layuot: {},
	feedback_object: {},
	feedback_object_to_server: { like_count: "love", dislike_count: false, feedback: "", feedback_name: "", feedback_email: "", first_name: "", last_name: "", phone_number: "" },
	price_breakdown_key: {},
	card_processing_fee: {},
	addressBook: [],
	taxTypeName: { city_rate: "city_tax", county_rate: "county_tax", state_rate: "state_tax", surtax_rate: "sur_tax", local_rate: "local_tax", special_dist_rate: "special_tax" },
	checkedEndCrossBracing: false,
	checkedSideCrossBracing: false,

	CheckDefaultLoadForTween: false,
	referrer: "",
	checkCaptuareImage: false,
	entry_wall_location_reverse: {
		left: "c_b_l_w",
		right: "c_b_r_w",
		front: "c_b_f_w",
		back: "c_b_b_w",
		ufend: "c_b_f_s_w",
		fubend: "c_b_f_s_b_w",
		c_b_l_w: "c_b_l_w",
		c_b_r_w: "c_b_r_w",
		c_b_f_w: "c_b_f_w",
		c_b_b_w: "c_b_b_w",
		c_b_f_s_w: "c_b_f_s_w",
		c_b_f_s_b_w: "c_b_f_s_b_w"
	},
	// entry_wall_location:{"F_S_L_R_W":"fsrside","c_b_l_s_w":"sideul","c_b_l_s_f_w":"lufend","c_b_l_s_b_w":"lubend","c_b_r_s_f_w":"rufend","c_b_r_s_b_w":"rubend","c_b_r_s_w":"ulside","c_b_l_w":"lside","c_b_r_w":"rside","c_b_f_w":"fend","c_b_b_w":"bend","c_b_f_s_w":"ufend","c_b_l_s_r_w":"rfend","c_b_r_s_l_w":"lfend","L_L_L_W":"lllside","L_L_F_W":"llfend","L_L_B_W":"llbend","R_L_F_W":"rlfend","R_L_B_W":"rlbend","R_L_R_W":"rlrside","L_L_F_S_W":"ufend","R_L_F_S_W":"ufend","F_L_F_S_W":"ufend","B_L_F_S_W":"ufend","F_L_F_W":"flfside","F_L_R_W":"flfend","F_L_L_W":"flbend","B_L_S_W":"blbside","B_L_F_W":"blfend","B_L_B_W":"blbend"},
	// "L_L_R_S_W":"llurside","R_L_L_S_W":"rlulside","B_L_B_S_W":"blulside","F_L_B_S_W":"flurside"
	entry_wall_location: {
		c_b_l_w: "lside",
		c_b_r_w: "rside",
		c_b_f_w: "fend",
		c_b_b_w: "bend",
		F_S_L_R_W: "fsrside",

		c_b_r_s_w: "ulside",
		c_b_l_s_w: "sideul",
		c_b_f_s_w: "ufend",
		c_b_b_s_w: "ubend",
		c_b_f_s_l_w: "fulside",
		c_b_f_s_r_w: "furside",
		c_b_f_s_b_w: "fubend",
		c_b_l_s_b_w: "lubend",
		c_b_l_s_r_w: "rfside",
		c_b_l_s_f_w: "lufend",
		c_b_r_s_l_w: "lfside",
		c_b_r_s_f_w: "rufend",
		c_b_r_s_b_w: "rubend",

		F_L_F_W: "flfside",
		F_L_R_W: "flfend",
		F_L_L_W: "flbend",
		F_L_L_S_W: "flubend",
		F_L_B_S_W: "flurside",
		F_L_R_S_W: "flufend",
		F_L_F_S_W: "flulside",

		L_L_L_W: "lllside",
		L_L_F_W: "llfend",
		L_L_B_W: "llbend",
		L_L_R_S_W: "llurside",
		L_L_F_S_W: "llufend",
		L_L_L_S_W: "llulside",
		L_L_B_S_W: "llubend",

		R_L_F_W: "rlfend",
		R_L_B_W: "rlbend",
		R_L_R_W: "rlrside",
		R_L_L_S_W: "rlulside",
		R_L_R_S_W: "rrurside",
		R_L_F_S_W: "rlufend",
		R_L_B_S_W: "rlubend",

		B_L_S_W: "blbside",
		B_L_F_W: "blfend",
		B_L_B_W: "blbend",
		B_L_B_S_W: "blulside",
		B_L_L_S_W: "blufend",
		B_L_F_S_W: "bluside",
		B_L_R_S_W: "blubend",

		G_F_L_F_W: "flfend",
		G_F_L_B_W: "flbend",
		G_F_L_R_W: "flrside",
		G_F_L_L_W: "fllside",
		G_F_L_F_S_W: "flufend",
		G_F_L_B_S_W: "flubend",
		G_F_L_R_S_W: "flurside",
		G_F_L_L_S_W: "flulside",

		G_B_L_F_W: "blfend",
		G_B_L_B_W: "blbend",
		G_B_L_R_W: "blrside",
		G_B_L_L_W: "bllside",
		G_B_L_F_S_W: "blufend",
		G_B_L_B_S_W: "blubend",
		G_B_L_R_S_W: "blurside",
		G_B_L_L_S_W: "blulside",

		G_L_L_F_W: "llfend",
		G_L_L_B_W: "llbend",
		G_L_L_R_W: "llrside",
		G_L_L_L_W: "lllside",
		G_L_L_F_S_W: "llufend",
		G_L_L_B_S_W: "llubend",
		G_L_L_R_S_W: "llurside",
		G_L_L_L_S_W: "llulside",

		G_R_L_F_W: "rlfend",
		G_R_L_B_W: "rlbend",
		G_R_L_R_W: "rlrside",
		G_R_L_L_W: "rllside",
		G_R_L_F_S_W: "rlufend",
		G_R_L_B_S_W: "rlubend",
		G_R_L_R_S_W: "rlurside",
		G_R_L_L_S_W: "rllulside"
	},

	updated_entry_wall_location: {
		lside: "Left",
		rside: "Right",
		fsrside: "Right",
		fend: "Front",
		bend: "Back",

		ulside: "Back Storage Right",
		sideul: "Back Storage Left",
		ufend: "Back Storage Front",
		ubend: "Back Storage Back",

		furside: "Front Storage Right",
		fulside: "Front Storage Left",
		fubend: "Front Storage Back",

		lubend: "Left Storage Back",
		rfside: "Left Storage Right",
		lufend: "Left Storage Front",

		lfside: "Right Storage Left",
		rufend: "Right Storage Front",
		rubend: "Right Storage Back",

		flfside: "Front Leanto Side",
		flfend: "Front Leanto Front",
		flbend: "Front Leanto Back",
		fllside: "Front Lean Left",
		flrside: "Front Lean Right",

		flurside: "Front Lean Storage Right",
		flufend: "Front Lean Storage Front",
		flulside: "Front Lean Storage Side",
		flulside2: "Front Lean Storage Left",
		flubend: "Front Lean Storage Back",

		lllside: "Left Leanto Side",
		lllside2: "Left Leanto Left",
		llfend: "Left Leanto Front",
		llbend: "Left Leanto Back",
		llrside: "Left Leanto Right",
		llurside: "Left Lean Storage Right",
		llufend: "Left Lean Storage Front",
		llulside: "Left Lean Storage Left",
		llubend: "Left Lean Storage Back",

		rlfend: "Right Leanto Front",
		rlbend: "Right Leanto Back",
		rlrside: "Right Leanto Side",
		rlrside2: "Right Leanto Right",
		rllside: "Right Leanto Left",
		rlulside: "Right Lean Storage Left",
		rrurside: "Right Lean Storage Right",
		rllulside: "Right Lean Storage Left",
		rlurside: "Right Lean Storage Right",
		rlufend: "Right Lean Storage Front",
		rlubend: "Right Lean Storage Back",

		blbside: "Back Leanto Side",
		blfend: "Back Leanto Front",
		blbend: "Back Leanto Back",
		bllside: "Back Leanto Left",
		blrside: "Back Leanto Right",
		blulside: "Back Lean Storage Left",
		blurside: "Back Lean Storage Right",
		blufend: "Back Lean Storage Front",
		bluside: "Back Lean Storage Side",
		blubend: "Back Lean Storage Back"
	},

	checkWallClose: {
		c_b_l_w: "p_l_w",
		c_b_r_w: "p_r_w",
		c_b_f_w: "p_f_w",
		c_b_b_w: "p_b_w",
		L_L_L_W: "p_b_c_b_l",
		L_L_F_W: "p_b_c_b_l_f",
		L_L_B_W: "p_b_c_b_l_b",
		R_L_F_W: "p_b_c_b_r_f",
		R_L_B_W: "p_b_c_b_r_b",
		R_L_R_W: "p_b_c_b_r",
		F_L_F_W: "p_b_c_b_f_l",
		F_L_R_W: "p_b_c_b_f_f",
		F_L_L_W: "p_b_c_b_f_b",
		B_L_S_W: "p_b_c_b_b_l",
		B_L_F_W: "p_b_c_b_b_f",
		B_L_B_W: "p_b_c_b_b_b",
		L_L_F_S_W: "utility",
		L_L_B_S_W: "utility",
		L_L_L_S_W: "utility",
		L_L_R_S_W: "utility",
		R_L_F_S_W: "utility",
		R_L_B_S_W: "utility",
		R_L_L_S_W: "utility",
		R_L_R_S_W: "utility",
		F_L_F_S_W: "utility",
		F_L_L_S_W: "utility",
		F_L_R_S_W: "utility",
		F_L_B_S_W: "utility",
		B_L_L_S_W: "utility",
		B_L_R_S_W: "utility",
		B_L_F_S_W: "utility",
		B_L_B_S_W: "utility",
		F_S_L_R_W: "p_r_w",
		c_b_f_s_w: "utility",
		c_b_l_s_w: "utility",
		c_b_b_s_w: "utility",
		c_b_r_s_w: "utility",
		R_S_F_W_VT: "utility",
		R_S_B_W_VT: "utility",
		R_S_F_2W_VT: "utility",
		R_S_B_2W_VT: "utility",
		c_b_r_s_f_w: "utility",
		c_b_r_s_b_w: "utility",
		c_b_r_s_l_w: "utility",
		c_b_l_s_r_w: "utility",
		c_b_l_s_b_w: "utility",
		c_b_l_s_f_w: "utility",
		L_S_F_W_VT: "utility",
		L_S_B_W_VT: "utility",
		L_S_F_2W_VT: "utility",
		L_S_B_2W_VT: "utility",
		L_S_B_2W_VT: "utility",
		c_b_f_s_l_w: "utility",
		c_b_f_s_r_w: "utility",
		c_b_f_s_b_w: "utility",
		c_b_f_s_l_w: "utility",
		c_b_f_s_r_w: "utility",
		c_b_f_s_b_w: "utility",
		G_F_L_F_W: "p_b_c_b_f_f",
		G_F_L_B_W: "p_b_c_b_f_b",
		G_F_L_L_W: "p_b_c_b_f_l",
		G_F_L_R_W: "p_b_c_b_f_r",
		G_F_L_F_S_W: "utility",
		G_F_L_B_S_W: "utility",
		G_F_L_L_S_W: "utility",
		G_F_L_R_S_W: "utility",
		G_B_L_F_W: "p_b_c_b_b_f",
		G_B_L_B_W: "p_b_c_b_b_b",
		G_B_L_L_W: "p_b_c_b_b_l",
		G_B_L_R_W: "p_b_c_b_b_r",
		G_B_L_F_S_W: "utility",
		G_B_L_B_S_W: "utility",
		G_B_L_L_S_W: "utility",
		G_B_L_R_S_W: "utility",
		G_L_L_F_W: "p_b_c_b_l_f",
		G_L_L_B_W: "p_b_c_b_l_b",
		G_L_L_L_W: "p_b_c_b_l",
		G_L_L_R_W: "p_b_c_b_l_r",
		G_L_L_F_S_W: "utility",
		G_L_L_B_S_W: "utility",
		G_L_L_L_S_W: "utility",
		G_L_L_R_S_W: "utility",
		G_R_L_F_W: "p_b_c_b_r_f",
		G_R_L_B_W: "p_b_c_b_r_b",
		G_R_L_L_W: "p_b_c_b_r",
		G_R_L_R_W: "p_b_c_b_r_r",
		G_R_L_F_S_W: "utility",
		G_R_L_B_S_W: "utility",
		G_R_L_L_S_W: "utility",
		G_R_L_R_S_W: "utility"
	},

	entry_component_location: {
		fsrside: "Right",
		front: "fend",
		back: "bend",
		left: "lside",
		right: "rside",
		FrontR: "rlfend",
		BarnRight: "rlrside",
		BackR: "rlbend",
		FrontL: "llfend",
		BarnLeft: "lllside",
		BackL: "llbend",
		FrontS: "ufend",
		RightS: "ufend",
		LeftS: "ufend"
	},

	entry_component_locationName: {
		fsrside: "Right",
		front: "front",
		back: "back",
		left: "left",
		right: "right",
		right_leanto_front: "right_leanto_front",
		right_leanto_side: "right_leanto_side",
		right_leanto_back: "right_leanto_back",
		left_leanto_front: "left_leanto_front",
		left_leanto_back: "left_leanto_back",
		left_leanto_side: "left_leanto_side",
		front_leanto_front: "front_leanto_front",
		front_leanto_back: "front_leanto_back",
		front_leanto_side: "front_leanto_side",
		back_leanto_front: "back_leanto_front",
		back_leanto_back: "back_leanto_back",
		back_leanto_side: "back_leanto_side",
		center_storage: "front_storage_front",
		right_leanto_storage: "right_storage_front",
		left_leanto_storage: "left_storage_front"
	},

	hide_price_calculation: 0,
	sendTaxarray: [],
	newCustomSizesArray: {
		"45_degree_angle": 0,
		automatic_openers: 0,
		certified_cost: 0,
		chain_hoist: 0,
		color_cost: 0,
		cost: 0,
		header_bar: 0,
		header_seal: 0,
		height: 8,
		id: 55374,
		is_automatic_openers: 0,
		is_certified: 0,
		is_chain_hoist: 0,
		is_header_bar: 0,
		is_header_seal: 0,
		map_id: 13,
		name: "8x8",
		side_cost: 0,
		vertical_side_cost: 0,
		width: 8
	},
	estimator_disclaimer: "",
	estimator_QuestionAnswer: [],
	estimator_DefaultQuestionAnswer: [],
	newTaxCalcuArray: [],
	MainBuilingImage: "",
	refData: "",
	checkBlobImg: false,
	showProcessLoaderchkEdit: true,
	editAPIDataByResponse: {},
	otherDataforPostAPI: {},
	BuildingPriceArrar: {},
	roofObject: {},
	leadSourceData: "",
	showProcessLoaderchk: false,
	tax: { percentage: 0, type: "%", name: "sales_tax", amount: 0 },
	is_loggedinUserData: {},
	taxDropDownValue: [
		{ value: "sales_tax", label: "Sales Tax" },
		{ value: "sur_tax", label: "Surtax" },
		{ value: "additional_tax", label: "Additional Tax" },
		{ value: "city_tax", label: "City Tax" },
		{ value: "county_tax", label: "County Tax" },
		{ value: "local_tax", label: "Local Tax" },
		{ value: "state_tax", label: "State Tax" },
		{ value: "federal_tax", label: "Federal Tax" },
		{ value: "indirect_tax", label: "Indirect Tax" },
		{ value: "material_tax", label: "Material Tax" },
		{ value: "special_tax", label: "Special Tax" }
	],
	othertaxDropDownValue: {
		sales_tax: "Sales Tax",
		sur_tax: "Surtax",
		additional_tax: "Additional Tax",
		city_tax: "City Tax",
		county_tax: "County Tax",
		local_tax: "Local Tax",
		state_tax: "State Tax",
		federal_tax: "Federal Tax",
		indirect_tax: "Indirect Tax",
		material_tax: "Material Tax",
		special_tax: "Special Tax"
	},
	customEntrySize: {
		"45_degree_angle": 0,
		automatic_openers: 0,
		certified_cost: 0,
		chain_hoist: 0,
		color_cost: 0,
		cost: 0,
		header_bar: 0,
		header_seal: 0,
		height: 8,
		id: 55374,
		is_automatic_openers: 0,
		is_certified: 0,
		is_chain_hoist: 0,
		is_header_bar: 0,
		is_header_seal: 0,
		map_id: 13,
		name: "8x8",
		side_cost: 0,
		vertical_side_cost: 0,
		width: 8
	},
	UpdatedPriceData: {
		roof_style_price_changed: true,
		lifttype_price_changed: true,
		cupola_price_changed: true,
		width_price_changed: true,
		length_price_changed: true,
		height_price_changed: true,
		insulation_price_changed: true,
		left_wall_price_changed: true,
		right_wall_price_changed: true,
		right_wall_cut_panel_price_changed: true,
		left_wall_cut_panel_price_changed: true,
		front_wall_price_changed: true,
		back_wall_price_changed: true,
		certificate_price_changed: true,
		common_width_changed: true,
		common_length_changed: true,
		common_height_changed: true,
		utility_price_changed: true,
		front_utility_price_changed: true,
		wainscot_price_changed: true,
		connection_fee_end_changed: true,
		connection_fee_side_changed: true,
		roof_pitch_price_changed: true,
		lifttype_price_changed: true,
		left_lean_roof_style_price_changed: true,
		left_lean_width_price_changed: true,
		left_lean_length_price_changed: true,
		left_lean_height_price_changed: true,
		left_lean_left_wall_price_changed: true,
		left_lean_front_wall_price_changed: true,
		left_lean_back_wall_price_changed: true,
		left_lean_certificate_price_changed: true,
		left_lean_utility_price_changed: true,
		left_lean_roof_pitch_price_changed: true,
		right_lean_roof_style_price_changed: true,
		right_lean_width_price_changed: true,
		right_lean_length_price_changed: true,
		right_lean_height_price_changed: true,
		right_lean_right_wall_price_changed: true,
		right_lean_front_wall_price_changed: true,
		right_lean_back_wall_price_changed: true,
		right_lean_certificate_price_changed: true,
		right_lean_utility_price_changed: true,
		right_lean_roof_pitch_price_changed: true,
		front_lean_roof_style_price_changed: true,
		front_lean_width_price_changed: true,
		front_lean_length_price_changed: true,
		front_lean_height_price_changed: true,
		front_lean_left_wall_price_changed: true,
		front_lean_front_wall_price_changed: true,
		front_lean_back_wall_price_changed: true,
		front_lean_certificate_price_changed: true,
		front_lean_utility_price_changed: true,
		front_lean_roof_pitch_price_changed: true,
		back_lean_roof_style_price_changed: true,
		back_lean_width_price_changed: true,
		back_lean_length_price_changed: true,
		back_lean_height_price_changed: true,
		back_lean_left_wall_price_changed: true,
		back_lean_front_wall_price_changed: true,
		back_lean_back_wall_price_changed: true,
		back_lean_certificate_price_changed: true,
		back_lean_utility_price_changed: true,
		back_lean_roof_pitch_price_changed: true,
		left_front_wrap_connection_fee_changed: true,
		right_front_wrap_connection_fee_changed: true,
		right_back_wrap_connection_fee_changed: true,
		left_back_wrap_connection_fee_changed: true,
		front_lean_insulation_price_changed: true,
		left_lean_insulation_price_changed: true,
		right_lean_insulation_price_changed: true,
		back_lean_insulation_price_changed: true,
		roof_color_price_changed: true,
		wall_color_price_changed: true,
		trim_color_price_changed: true,
		truss_price_changed: true,
		left_lean_right_wall_price_changed: true,
		right_lean_left_wall_price_changed: true,
		front_lean_right_wall_price_changed: true,
		back_lean_right_wall_price_changed: true,
		siding_material_price_changed: true,
		frontLean_truss_price_changed: true,
		backLean_truss_price_changed: true,
		rightLean_truss_price_changed: true,
		leftLean_truss_price_changed: true,
		common_left_lean_length_changed: true,
		common_right_lean_length_changed: true,
		common_front_lean_length_changed: true,
		common_back_lean_length_changed: true,
		common_left_lean_width_changed: true,
		common_right_lean_width_changed: true,
		common_front_lean_width_changed: true,
		common_back_lean_width_changed: true
	},
	inputs: [],
	Componentinputs: [],
	MoreTaxinputs: [],
	CheckSnowLoadValue: 35,
	CheckSnowLoadFlag: false,
	loginRememberMe: false,
	additionalFeaturesArray: [],
	additionalFeaturesArrayWithPosition: [],
	ExtraItemsFeaturesArray: [],
	extraItemsFeaturesCost: [],
	extraItemsFeaturesQuantityCost: [],
	ExtraItemsFeaturesQuantityArray: [],
	extraAddOnItemsArray: [],
	ExtraItemsFeaturesDropdownQuantityArray: [],
	makeCertificateArrayLeft: {},
	makeCertificateArrayRight: {},
	makeCertificateArrayFront: {},
	makeCertificateArrayBack: {},
	frontCertArr: {},
	leftCertArr: {},
	rightCertArr: {},
	backCertArr: {},
	stateChangeflag: "",
	stateMenuChangeflag: "",
	loginErrorHandlingMessage: "",
	username: "",
	defalutProductLoad: false,
	loginSession: false,
	isShowfeedbackModule: false,
	IsMentananceWindow: false,
	logininitial: false,
	defaultBuildingArr: [],
	checkLoadDefaultBuildingRespone: false,
	sideDistance1: 0,
	FrontLeandrop_arr: {},
	BackLeandrop_arr: {},
	LeftLeandrop_arr: {},
	RightLeandrop_arr: {},
	llsh: false,
	rlsh: false,
	flsh: false,
	blsh: false,
	rlff: false,
	llff: false,
	font: "",
	p_i_o_other: "",
	doorWall: "",
	sign_jpeg: "",
	sigPad: {},
	textureImageForRoofSecond: "",
	textureImageForRoof: "",
	textureImageForRoofL: "",
	textureImageForRoofR: "",
	leanGetDataLeftComparision: "",
	leanGetDataFrontComparision: "",
	leanGetDataBackComparision: "",
	leanGetDataRightComparision: "",
	leanGetDataRight: "",
	leanGetDataLeft: "",
	newLeanArr: [],
	dimensionsLeanLWF: [],
	dimensionsLeanLDF: [],
	dimensionsLeanLHF: [],
	dimensionsLeanLWB: [],
	dimensionsLeanLDB: [],
	dimensionsLeanLHB: [],
	dimensionsLeanLH: [],
	dimensionsLeanLW: [],
	dimensionsLeanLD: [],
	dimensionsLeanLH: [],
	dimensionsLeanLWR: [],
	dimensionsLeanLDR: [],
	dimensionsLeanLHR: [],
	leanGetDataFront: "",
	leanGetDataBack: "",
	leanGetDataLeft: "",
	leanGetDataRight: "",
	mapIdforLean: "",
	leantoCompare: [],
	leanto: [],
	checkoutModal: false,
	isShowSaveLater: false,
	isShowDoorwindowmobile: false,
	resizeCalledOnce: "",
	walkFrameoutInitialValue: "",
	walkInitialValue: "",
	windowsFrameoutInitialValue: "",
	windowsInitialValue: "",
	customFrameoutInitialSize: "",
	garageInitialValue: "",
	confirmStateError: false,
	confirmState: false,
	tabCountDisplay: false,
	ClickforPhotosMobile: false,
	doorProperty: {},
	pos: "",
	submitCheckoutBtn: false,
	shippingState: "",
	editComponentDimension: "",
	commonDoorType: "",
	doorUniqueId: "",
	legCutFee: false,
	legCutFeeMnfs: [8, 121, 122],
	doorUniqueIndex: "",
	object_name: "",
	billingState: "",
	paymentFailedMessage: false,
	stripeErrorHandlingMessage: "",
	showDefaultInsullation: false,
	BuildingRoofPitch: {},
	BuildingRoofPitchObj: {},
	BuildingLRoofPitch: {},
	showInsulation: true,
	frameDimension: "",
	frameHDimension: "",
	invoicePDFURL: "",
	showWainscotJSX: false,
	showWallColorJSX: false,
	showComponentEditBox: false,
	timer: null,
	showCupolaEditBox: false,
	hasDoublelegshow: false,
	hasDoublelegName: "Single",
	hasDoublelegdisable: false,
	leanHasDoublelegshow: false,
	leanHasDoublelegName: "Single",
	leanHasDoublelegdisable: false,
	leanFHasDoublelegshow: false,
	leanFHasDoublelegName: "Single",
	leanFHasDoublelegdisable: false,
	leanRHasDoublelegshow: false,
	leanRHasDoublelegName: "Single",
	leanRHasDoublelegdisable: false,
	leanBHasDoublelegshow: false,
	leanBHasDoublelegName: "Single",
	leanBHasDoublelegdisable: false,
	compareLeanLegs: { leftLean: {}, rightLean: {}, frontLean: {}, backLean: {} },
	isAutoRotate: false,
	cupolaObj: {},
	componentLabel: "",
	StopPRAPI: false,
	checkoutBtnDisabled: false,
	orderLaterSubmitBtn: false,
	checkValidatePattern: false,
	checkValidate: false,
	checkStripeID: false,
	pdfURL: "",
	exactDoorType: "Garage",
	targetRedirectUrl: {
		order: {
			create: "orders/3d_create?sensei=2.0",
			edit: "orders/3d_edit/",
			view: "orders/",
			duplicate: "orders/3d_duplicate/",
			visualform: "create"
		},
		quote: {
			create: "quotes/3d_create?sensei=2.0",
			edit: "quotes/3d_edit/",
			view: "quotes/",
			duplicate: "quotes/3d_duplicate/",
			visualform: "create"
		},
		inventory: {
			create: "inventory/3d_create?sensei=2.0",
			edit: "inventory/3d_edit/",
			view: "inventory/",
			duplicate: "inventory/3d_duplicate/",
			visualform: "create"
		}
	},
	setCustomRangeR_and_B: {
		1: { width: "12-50", height: { "6-11": 20, "12-16": 22, "17-20": 25 } },
		2: { width: "12-50", height: { "6-11": 20, "12-16": 22, "17-20": 25 } },
		3: { width: "12-50", height: { "6-16": 22, "17-20": 25 } }
	},
	paymentOption:
		window.paymentOption != undefined ? window.paymentOption : { enabled: "yes", testmode: "yes", key: "pk_test_rdFjxhfdgUp51mDhmHz2VjTL", test_secret_key: "", publishable_key: "", secret_key: "", type: 1 },
	// crmSetting :(window.crmSetting!=undefined)?window.crmSetting:{"crm_product_id":"21","api_token":"xhkZaSoQHjhlFHCOQgesOnsy7o1juN0tkg8wMfk8JAVljzl4XdPsPj5AzlDeZnoT","stripe_detail":{"enabled":"yes","testmode":"yes","test_publishable_key":"pk_test_rdFjxhfdgUp51mDhmHz2VjTL","test_secret_key":"","publishable_key":"","secret_key":""},"api_post_url":"https://crm.senseicrm.com", "email":"hello@americanmetalbuildings.com","phone_number": "+1 (888) 896-0027"},
	//crmSetting :(window.crmSetting!=undefined)?window.crmSetting:{"crm_product_id":"11","api_token":"1ygRgrlamRCw72eCT0uBKtGwLKNhyLTSMGv65pgwhiPxuT9rybMIrhvjjVFTGL8W","stripe_detail":{"enabled":"yes","testmode":"yes","test_publishable_key":"pk_test_rdFjxhfdgUp51mDhmHz2VjTL","test_secret_key":"","publishable_key":"","secret_key":""},"api_post_url":"https://10x.cibirix.com", "email":"hello@americanmetalbuildings.com","phone_number": "+1 (888) 896-0027"},
	// 5M0njqYPUOWBbp3Yts2Ktio7FiPqB2tik7BJh7o1Hn94akMjf5UFArj9rXn1e4Sq
	// BuxsjbgSeOWw33lUPMCqZsmbzXWGwcLgV0NOw1UsguS3STvB2z0ffmTKAbU28uDL
	// 1ygRgrlamRCw72eCT0uBKtGwLKNhyLTSMGv65pgwhiPxuT9rybMIrhvjjVFTGL8W
	//9vZYfym4VG99tLmdoqWYI8TYW01klRpr7ywM7SA5 crm
	//Jr9ORHkgSCav399MX0qVj8nkzQXLIw8X4RJCLpUd pre
	//vaibhavcibirix.com

	get crmSetting() {
		return getCRMSettings();
	},
	isCheckColoredScrews: true,
	isCheckGroundCertificate: true,
	stateManufacturer: {},
	stateManufacturerAcordingAPI: {},
	stateManufacturerAcordingAPIDiscount: {},
	stateManufacturerNewDiscount: {},
	stateNameAcordingAPI: {},
	stateDataForCompare: {},
	editstateColorAcordingAPI: {},
	LogIm: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKoAAABuCAYAAAC3D4ggAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyhpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ1IDc5LjE2MzQ5OSwgMjAxOC8wOC8xMy0xNjo0MDoyMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTkgKE1hY2ludG9zaCkiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6N0YxRkE0NzlGQzU1MTFFOEI0OTlFMDI4RDJCMDhCRTYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6N0YxRkE0N0FGQzU1MTFFOEI0OTlFMDI4RDJCMDhCRTYiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo3RjFGQTQ3N0ZDNTUxMUU4QjQ5OUUwMjhEMkIwOEJFNiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo3RjFGQTQ3OEZDNTUxMUU4QjQ5OUUwMjhEMkIwOEJFNiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PhdBdNcAABYhSURBVHja7F13cFtHfn7onQABEOwASIBFheoiKVHFMiVbli2f73xyudGdL/Y5sT32jScZXzKT+yPlbiY3uUyczBUn8rnFiotO9vlkybJsyZZkWcWURImUWMQGFrCCAkD0ml1on7V5QiHBhrLfzA6Ah1d3v/2199tdVjgcpggIUh1sUgUEhKgEBISoBISoBASEqNmB3s7xEseUR05qYm7AJVUwtzCbrIVvvny6/NJZkzRHLgp+78n1o7v21FxnsVlBUjvJg0XCU3MDy5hD/dqvT1deONUtm7rp5nO4bCoUClPBQIjSVeW5nvt5Y9+qutJeFosVIrVFiLrgGDXb8w/tv6z90xtN6kAwzOVy77SmYBW7HF5q4/YK249e3Gyqqsk3kZojRF0QTAIJeuC1pvITH7XmTow6+CIxP+ExPl+AEgh5/i07q+yPP1vfV1KmNJOaJESdF0zZ3Yr/+c3Zyq+OtCvGRxwCHp9DsdmsaR8Pq9sPCJurFvs27ai0PfE3W9pz5EIrqVlC1DmB3eZRHHnnSvn7+85rXE4vj8PhUCzW7M4ZAParRMr3732hYXjnnppuIJUdpKYJUZOToFZA0ANXyv705sW8sUG7QCTlz/k1nFNeSl+d5378r+qHGx9cegM4Yj5S84So04LX45ccfP1i1bGDLaqBHosQ2JYzUvEzBYwOQBu2amWh84mfbhqs22boJK1AiBqXoJ8eaDXu/92ZAuukm8/hsOeVoHcQNhiixBKBv9So9P70H+/tKq9SD5BWIUT9Fm6XT3rqcId+/2/PFA71W4XT8eLnE6FQJNwauHv3Mttjz9b1leizO0KQ9UQFDg3/6PtXqw/tv5zX2TIiFkmAiuekzptlj9tPKfMkvi27llh/+PzGG3KlaJIQNYsAVCzv5JGOirf+46tis+mmEKp4Djc1Ux/CoTDlDwQBYaXeB/eumXj4L9a1C4RcFyFqBsPvDwovfdWn3ferL7V9NyZEQuAkUaz0uX+fN0Cp82Xep/922+Cmeyt6eHyOhxA1gwCkEuf0sRsVH7zxTeHlMyapRMpPKRU/M/s1TLmmvNTKjTrHIz+pG27YYWwnRM2AZzz/RXfF2787W9x2aUgK1TuPx8kU7UBJpAJ/+RKNB0jY3kzOIchYogKpw227ZNb+9pfH9TdaRiQzfdWZbhJWIOL51zToHU//bOuNghL5KCFqGqDlwkD5e69eKD79SYdCIhNkLEHviGAACcvlsgMP/XjdxHefWNur0kgnCFFTENeaBsv3//5cSWvTgNjj8vP4guzLC4fN6XH6qEJ9ruee7y2ffPQv69oyIUKQEUSFwz5+/4sThr7OcaE9krQ8+4SRTDAHAoEgpdbIvD/+6y1DjQ8uSescgrQmak/HWOm7r5zXnjnWmQMeg5sqKp6u0lTpLPClgaE6z/X0z7b1r92s70nHYTFpSdSejonSA/vOl0KCuoGKB6pt0YkJ39EHgQRjs9kU7bjBJBOYbAK3wcx/1iJ2JHgfbpePathRaXvsufrBmrUlPYSo84TRIXv+f//qZEXrN/2SyQknn8/nLprUCocoyguI6APSii9kU6sbyuwVSwvclTX5U7V3lQ+KxHzn9eYhXfPX/bk97RPi1iaTZLjfzueDTgVt58WS/rDzKJRiX8WyAvfz/7C9s7BUMUKIOlcENdvz3/2v82Wff9iqCPpDvEgjsxaDnOFI7BI4alRhqdS37cHlN9c2lN9UF0rcJWWqCR4v9lsis2mycLjfJv3mdG/uqcNtiiGTTSAU8ygub3Hs6WAwDCQ/23/fo6smf/BMfVeq5xCkNFGHB6wFf97frD38zmVlRMUvoBcP6yUEGpOuH9CQPk2J3Lfju8ssm7ZXmiU5ArdAyHMmc26YSjg57pB9+mFr8cnDHbkuu5djm3TxYeeDZsJCSttI0otG4nv4ybqx+x9b2SOV8W2EqNOE1eJSvfmfX1WcO96dM2YGkkfEA1KHtQBSJhR5lx4Cn8VluZ5incpXqlN46xoNltUN+n4ul+Odr+f9/KOW0rbmUelgt0XQ1TYqhqYFX8CJSNyFiBBALaGrUrsf2rt2/IEfrLzO4bD9hKgxAId9vPfq+YpP3r2ick7BcUnz64DAR4chHK87EHGEqtcUujbfU23VGpSusiqVXWfUDC10HcDZVdoumTW9nePS8yd75E1f9shgTgI0EzjznJsQCWkB06a0XOl+7ufbTasbdL1AugcIUTGJ8smBFt2BV89rHDbPvAXq4bPCx4Wffl+QyiuQedc16B2b76uaKKvWWKVygSuVBtjBTC/bpFt2rWlQfeT9Zk3b5WGRxx3gcXlsZNey5sW+jcxDMOWl1m8z2J94cVP/stVFvVlNVKfDm3PwtaaKzz5oVQ71TgrhwLm5VPGRsBGQlIFIiIiiinRKj0IlChiXqV27Hl1tLqvQmNMppgikneDy173aw+9dKhg2ufj93RNivz8QyQIDZsmc27awM4NOEdi4o8L+wxca+rQG1VBWERUY8NIP37hYeWj/ZfXE6JQAxhjnKuWOlpbQ5uIJ2FTtXUZb5fICl75C5VrToB+RK8WZkiHPunFttPTKOZOys3VE0nJhQDLUZxUIgD0PNdJc9feIeQQ6g1wl9m3YZrQ/9dLW9pxc0c2MJqrL6ZV98XGH/q2XTxdZLU4+j8+ds8qEAW3owRaWyr112w32zdsrLfmlcmdBsdwCHBIvleEYH7ZrRgZs0lOftOWd+qRdMWZ28gUw/DWHoxZgHfMEHP/e5zeN7nqspkcqE9oyiqiRkZ0fXDN89GaTprttXCSRJa/iYSwTeufwvuE51IUyj0whDG7abrDe+/3VA3KlaCpbst5jq+yA0DLmlH/09kXd2c+75D5PkGUZdwgo0NQcDmvW2gvOo1VqUHn2PFU7unNPTcdCCIJ5JWoQDpw72FJ18PWmfFPHhAiGW5IZlwSD03AanABQ6SWGXI/WoPaWlCs8azbqrWsbyvqBZM5qYiYCcMiUXx6+VtrePCLp67YIO5rNEirMogQibtLjxKCwgCaWoVrj+tGLm4cadhg7oBxJK6KCBxCePdGt3/cvX5SOme1CWBkzNfRhqMTrClDQWTAsyfNs2lV9s2Z1sb24XDlVrMsdJvRLPvzVfW1MDexb2fGPrytbvxmQ8Lk8SiBO7rVuJKQFCbs83/niP9/bXVVTYEp5ogYCQcHZz3vK/veVr4vaL5slMGl52mGjEHobBB4cmAZ+rTHX+52960ZX1etGRVKeVygi8zLNNXzegMjl8Imbz5k0f3z9fEH/jZsCrzvAY3NYEbPqVpk+YUPBUHDbA0utjz9bb9Ia5zZCMCdEBadgnzzSUfXhW00FLef6pXxRAiMeepIR1RGIVEZJmdKjzpf6y5dqXDseWj5iWKIxp0qgOZsATbXmC/3azw62agZNVkFX67AU2LeRt2MwI2w6pKXnIdjYWAFjsJ25eRLLohMVjuxsPtdf9sovT+h6O8fFt+J57DhhjlthI4odplZt0DnWby63ATXuqaktGVfny8YJVVIHgBfsztaR0o6WEXnLhX7ZF4euK72eECUS8yhegqw1yKmAP0TJVSLfzj2rLI8/U9s+2xcpSREVEvTqhUH9ay+f0racG5CKJPyoN07nafo8AUquFvnXbzXY73u4Ziy/OMepypfak03qIFho0lLsiRG7emLMKf7y4+saQNrciWEnnw+dMQ47Lmn93gClUEt8T7101+DWXVW9yQ6LmTFRL3/db/zgjabC00fbFcBuhG8ubpMyEKKCoRAFbXJNUY5HlisKbthWbrvn4RWDgJjW+UrqIFhYwGmQLGOO3CPvNpeeO94ldzn97FGzTRgJf3E5kRAYQ7BFptZcXqd1PPKT2uEtOytnHCGYNlHbLpnL9v3bSd1At0UAU9Jg0jI0oGG2ESwCIYdat8VgK1+icVcsVTnWbzUOSaRCO2nWOVfJPGDXw9e+KbNohWXCoTpzrKO459qEpK15SNx+dVgM0xWFYv7/Iy00/aCGrV5V7Hjm77aZlq0r7pkzona1jWv/8K9f6q9dHBQDu4OHwk/A1vRR+kqlZ+v9S60rN+itmgKJq7RcPUqcoPmD1+utNpvNFcFg0Gs0Go+l4j1OWd2Kvm6L0tQxLj18oFndemFIwufzIjFbOvwFBRzQxP41G8ucT760uUdbnjhCEJOoN66NaQ+8er70sz+2Kjh8Nhs6STlKka9Qp/DtemTFWO1mw4hYxvcsgp25mkouvx/mV7akuTStcLvd1eCrUywWn0j1+4XZX26XX3j1Qn/BoXeuaHrbRkX2SXfEoWGDAqUrh8sK7Hps1eT3n1rfV1Ace+KMO4jadX1M+5t/+txw8VS3JFcjDixbo3UV6OXeTdsrLavqtKZFTqiFBvH9szj+UJoL1QpQqoFEdXI4nBPpdvPQtv3mZHfZ2RPdysG+m4LWCyaZzwsHRYapIiAAG7+z7ObeFza0iSWCqZhEhUOPIUFvTjq4W3ZUW3UVua7KmkJriV6dShPIwvt9IMk8AWjTHc4EokKJCsqJdH4QGDlqvTygM5tsouav++VHD15Ruaf8cKbCwDN/f/fQvXtqOvExaKzJMYcKGL/qUCjEqlxeMClXiqf4Aq47RZ8v2yVqNSIrjJ4cozIHrEmLU2kZcUiOHrxc+Oe3L6lkOdLQi7/Y2bex0dALk15YgKDsNFv2UIBsVKZxXQcKXCQX2jlXmBWBJGomrDYihFoUlcyMbABpOzxkzfvDvx83BD0s9u7H14xk0txT9aDkgQKTIq6SGEHmYNLiUGXSMuhsTHoSZBCUKqmFTaqBIJ2kEAFBSoObhc9ciLxnKfptQTZttOweFaojGDuONSgwBxQRctbwDLB8YP8HgaMabTJdMSiyKMfgDpMceff4gr7wzaAyyvZvr4mcLDq1TgfKMlDgLBYu9JxpmaWWbRLVCMo6jKQ0Gbch4jCxApRaUBoQGaNhK9qnFjerAoFAbSgU2oBIycR6tH89Il6s666Ocv/0cUwUof82ot9adB4O1jnqUQcgRE1h5IKyJEHUgInr2PeyKP9rse/42qX2W6tPs6gYROUxpGs0iUpFkeJ0SCpamI2en8CPzrkyxnOuIkRNbeANBIf5wkQIOOWiByOHlnHMKEYObZRz6rDvfQxCBRFRJVGOw8foSGOYBlQMcyQRYCdoRN9DyAyYYpgqUmKjpiZUqHEggcaoW8kpPsyuW4GIWg5KP+PYQVD0iAB5mI0HTQEF+j6BJNm3ACR1AxtVGoUUAoaAkEURHrxZEJUGtGPPULdet1JIwmoxO/0GkaipB1ryQYfiIkN1QqnZi5GGuVpvbwz1XxZjHxpOJFGZRJTEkJ4U1gG+PccsnvkC4/grmHmgJKo/NaGJQygImMBL5zfkMf5zYKozP4p9GkAmxB1EjUFEaRxiMomcLFGtMaICozE6CyFqCkCEVClUhbHmAwghu5XC1DkOfKx6KfKcafUcK+nXEcUejSZheTFMASj1k32/Heue6Dmj+ISoqQc5Jp3i5dJOxZE2fQynbAtDGscjKpfh5UviOE+4xJ3N2lCTCZ6RR4iaepBN0zFxYN4/E+EY6t0R57yOGESkifop5rhJo/w/m1RLZxwHKy3bPhu8fjEmRWRx9pMmkDbQvi2IYxJEI0UIEUKKmRZiTLU7oxBVNAcevz+OifNtYIIQNbUgwEIyhdPYP9ak+ROIXPwYJkEssoqwDsJFxPUxJF80ok4l+bzx7Nq0JWo2qP6ZdsZ4DYhL0BEq8ZBlN0OKShjS0snYzseu75gHoqYtsoGoM11WJJ5HjDs400nucDCIKGYQ1MWQqNIY18p6ZIPqD2OkSTRdJYvhcDCBvzItmobqZxJVyiBqAEllPkPtBxNEKAhRMxAhzMZsn8V5YDQAj7GqkP3rnQZReQzCTjEkpxTtI4ninRNkier3M6RVsoiWPVWe4Bg8TCShoieb0PvsBKVqDjx+QtQ0hZdhHyaL0ijbtAmOwe3Mu5EUZm53JiA4QZYQlWknJgNazUdzvPISmB3+KBIejxZMEaISokLYsWdNNrsdV/ufoZKM+odwx+hIVALyEqJmOPDFu0qSPEchRioPKjTBNAmcUlcC4rriaAGCLCJqEJNQ+mnsz4ljh+JJ1XjKoH4GEpVJQg9154uDeV2OKB0nHcmWfNRB7Hlr4+wH/zMwtuEk7IvxXT8NGzmeWvctFEkhFmJJeULU5ICn4sHk583IQYKxSxjDrKRuhYfyGccJMbt2nLqdIU+DfoGAD0tJZG8m8vLdFMEdyJYxU1C1wjFCFeg3JNXGaXTeRMNNejD7FTpVl6Zho7piEFUV539io2bgM8XSa/CtlG0a9hmed6rD7NxosyFPYqq6OMa18XBUmIo+1NkxTY+fleAZE7UpixB18eGNYu8xcQrYZ5ORlQLvJCzMFz1O3R5rpMA0Tl+cc3Zj34ti7GNlfEa7NpVgH5r0sezYwDRMhyD2GUor6ZNB007OBPlIZfORqoW2poUiIEQlICCqn4AQlYCAEJWAgBCVgBCVgIAQlYCAEJWAEJWAgBCVgBCVgIAQlYBgTrCo+ajhcNgYDsMlacK8W1nnrDbw0bWAtwBHkMLVUGay6jRcWcWI/U6FtVfh4hL4cHC4dP1FQtS5wRJAziJATFChrHRZpIuewPcclXoLi11FnQYSdgPqTF2EqLODHFUkzP9kZrTD4SE7sd9tqMJ16Bg/Oh6SZQXaHxaY09mEzgcl5Vq0HV+xbgVqSAlDAu1GjdyFGpn+7xR1O1dUh7Yfp6LPC1WErkkxrgmlnRX934buiZbI+D3Dc69Dz+ZC+51C3+mVs3FCJoIf61xyhqQVo/syo/s6h64xjl2H7oxG6vb6XIsmqReLqArUAK4YFXyIoZrphhGjxj6F/mM25hLUkGsR6brQNvj7KHbti1ij4Kof7utEZIzWucxU7MnLzKhQWOPSUlfC6JRt6LMedYA21Imc2LPVY+ei0D3S26PdxwpU6A5gwjobLQAaETGt2Dbc7HGh3yvQ/VvR56JrkFQcM4VLFlzK0hXZxSA13fj9qFJpidCFfRoZUiVWpbvQvisYjR0Nu7HvhxhSnGJ0QhP2G5dQFCY98zBSORmSWs64niLKM+CSdgt6hqsMaYzXJRXFth7GiJ6H1S+830LUofzZRFQrIqQ4ilTVYY1Pq6iFgglTdyuwbTShdFHIWY9JYxNqTB3D4cJJsgRJdDN2jURom6G9Cc+tRiRXYNI8mbo8jp6lCHWA49kUnrIhQqyj4s/dlJfgPDzMnjSic44z7EDarrUlkOIUw750MaSPCVPXiSZcm87UQTzq9hBr+v50mMSkMY7Zx9PVSJBUE1HuKdnVULrQ8y/aaiqLqfppZ6ieQYYuVNG7UQP6EzQ27fzY0LF+RLQlqLjiOABWdFwjuraf4eiYGGbGWXTORkano6VePTreFcfBaWM4XTSuoI67m7G9C5GsETvH0Sjnxm1UMyaBtdixMx2KzXRsFy0Ml85jppKJgaYLjFhUhMw8TWXPBBTpgLXU7eHWtBYgJM0AiUqQRSDv+gkIUQkICFEJCFEJCFIN/yfAAFXp2JWBy8rXAAAAAElFTkSuQmCC",
	calCulationVal: 0,
	calCulationValIndex: 0,
	checkIsEditData: false,
	twoDImageObj: [],
	twodImageData: "",
	isActiveSlide: true,
	buildingWidthArrayCust: [],
	buildingLengthArrayCust: [],
	buildingWidthArray: [],
	buildingLengthArray: [],
	buildingHeightArray: [],
	main_gauge_arr: {},
	door_h_arr: {},
	door_w_arr: {},
	selectedRoofColor: "",
	building: [],
	ExtraBuildingID: [],
	roof_style: [],
	roof_style_Barn: [],
	roof_style_Barn_with_centerbuilding: [],
	anchors_cost: [],
	garageDoorColor: [],
	selectedBuilding: [],
	trsArr: {},
	reg_d: "",
	s_v: "",
	bjD: [],
	bjDData: [],
	AllBuildingData: [],
	dtr: {},
	p_l_r: {},
	b_p_r: {},
	r_s_a: {},
	g_d_a: [],
	w_o_a: {},
	w_d_a: {},
	callMesure: false,
	roofAction: true,
	g_d_a_p: [],
	g_d_s_p: [],
	w_o_p: [],
	w_o_p_s: [],
	w_d_p: [],
	w_d_p_s: [],
	showCustomerModal: false,
	isSlidebarOpen: false,
	doorWallArrayValue: { Front: params.p_f_w, Back: params.p_b_w, Left: params.p_l_w, Right: params.p_r_w },
	//ManageDoorArrar :{"front":[],"back":[],"left":[],"right":[]},
	ManageDoorWallVal: {
		front: "Front",
		back: "Back",
		left: "Left",
		right: "Right",
		Ltleft: "Left Leanto Left",
		Ltright: "Right Leanto Right",
		FrontL: "Left Leanto Front",
		FrontR: "Right Leanto Front",
		BackL: "Left Leanto Back",
		BackR: "Right Leanto Back",
		LeftS: "Left Leanto Utility Front",
		RightS: "Right Leanto Utility Front",
		BarnRight: "Right Leanto Right",
		BarnLeft: "Left Leanto Left"
	},

	defaultBuildingJson: {
		building_id: 4,
		id: 261,
		image_name: "Commercial_Buildings.png",
		leanto: null,
		leanto_size: "0x0x0",
		leanto_wall: null,
		manufacturer_id: 17,
		name: "Commercial Buildings",
		other_building_id: "4,10",
		roof_color: "#2f0e13",
		roof_id: 3,
		size: "32x31x9",
		trim_color: "#2f0e13",
		utility: 0,
		wall: "close",
		wall_color: "#ebe0d3"
	},
	ManageDoorValue: 0,
	walls: [],
	coords: null,
	c_m_a: [],
	c_m_a_Anchors: {},
	c_m_a_Colors: {},
	DistanceArr: [],
	DistanceArrCompare: [],
	ConditionArr: [],
	ConditionArrForLean: [],
	ConditionArrCompare: [],
	conditionArrForLeanCompare: [],
	BarnConditionArr: [],
	main_extraItems_arr: { Select: "Select" },
	t_c: 0,
	t_c_b: 0,
	g_v: "14",
	map: { 2: "box_style_cost", 1: "regular_cost", 3: "vertical_roof_cost", 8: "regular_cost", 4: "vertical_roof_cost", 5: "box_style_cost", 6: "vertical_roof_cost", 7: "box_style_cost" },
	e_i_a: [],
	e_i_b_a: [0],
	g_v_a: [],
	c_f_a: [],
	c_f_a_per: [],
	c_f_a_sCer: [],
	c_f_aCer: [],
	c_f_i_a: [],
	c_f_a_b: [],
	c_f_i_a_b: [],
	c_f_b_a: [],
	f_r_o_d: "",
	f_r_o_d_p: 0,
	d_w_a_r: [],
	a_p_d_a: [],
	a_p_d_a_b: [],
	door_arry: { window: [], garage: [], door: [], frameout: [] },
	c_k_p_d: true,
	d_v_i: "front",
	d_b_u_g: false,
	i_c_l_g: true,
	i_c_l_g_n: true,
	checkIval: 0,
	SetFlag: false,
	b_r_p_a: [],
	b_r_p_l_to_a: [],
	container: "",
	scene: "",
	camera: "",
	renderer: "",
	controls: "",
	tween: "",
	dragControls: "",
	b_h_t1Bx: "",
	b_h_t2Bx: "",
	b_h_t3Bx: "",
	b_h_t4Bx: "",
	b_h_t5Bx: "",
	b_h_t6Bx: "",
	b_h_t7Bx: "",
	b_h_t8Bx: "",
	ground: "",
	foundation: "",
	c_b_g_p: "",
	c_b_g_f: "",
	c_b_g_b: "",
	c_b_g_r: "",
	b_i_g_B: "",
	b_B_g_B: "",
	b_r_f_R: "",
	b_r_f_L: "",
	b_r_f_l_t_L: "",
	b_r_f_l_t_R: "",
	b_r_f_E_R: "",
	b_r_f_E_L: "",
	b_m_a_n: "",
	b_a_p_l: "",
	b_t_u_k: "",
	b_d_a_y: "",
	b_c_p_2: "",
	b_c_p_3: "",
	halfTruss: "",
	b_l_g: "",
	b_T_t_L_u: "",
	b_T_t_L_u_S: "",
	driveway: "",
	truck: "",
	b_w_b_c_l: "",
	b_w_b_c_r: "",
	b_f_g_p: "",
	b_f_g_p_r_L: "",
	b_f_g_p_r_R: "",
	b_t_M_R: new THREE.Group(),
	b_t_M_L: new THREE.Group(),
	F_S_L_R: new THREE.Group(),
	b_t_M_F_t_F: new THREE.Group(),
	b_t_M_B_t_B: new THREE.Group(),
	b_t_M_L_t_L: new THREE.Group(),
	b_t_M_R_t_R: new THREE.Group(),
	wainScote: new THREE.Group(),
	R_F_P: new THREE.Group(),
	L_F_P: new THREE.Group(),
	R_B_P: new THREE.Group(),
	L_B_P: new THREE.Group(),
	L_F_L_P: new THREE.Group(),
	R_F_L_P: new THREE.Group(),
	b_t_M_L_t_R: "",
	wallsForCut: {},
	originalLeg: null,
	originalConnector: null,
	legsForCut: {
		front: {},
		back: {},
		left: {},
		right: {},
		frontLean: {},
		backLean: {},
		leftLean: {},
		rightLean: {},
		leftFrontLean: {},
		leftBackLean: {},
		rightFrontLean: {},
		rightBackLean: {},
		frontFrontLean: {},
		frontBackLean: {},
		backFrontLean: {},
		backBackLean: {}
	},
	legsForCutFee: {
		left: {},
		right: {},
		leftLean: {},
		rightLean: {},
		frontLean: {},
		backLean: {}
	},

	originalWainscot: null,
	originalChannel: null,
	c_b_h_c: [],
	Webbing: "",
	b_r_c_r: "",
	b_w_c_r: "",
	b_t_c_r: "",
	b_w_s_c_r: "",
	b_a_d_I_O_t: "",
	b_s_t_s: "",
	b_p_i_g_u_l: "",
	b_i_d_e: false,
	b_s_c_s_X: 0,
	b_s_c_s_Y: 0,
	b_i_R_z_D: false,
	b_m_P_s_X: 0,
	b_m_P_s_Y: 0,
	checkBitly: false,
	b_s_c_n: null,
	offset: new THREE.Vector3(),
	custDM: {},
	b_d_g_b_O_c: [],
	b_d_g_b_O_cN: [],
	b_d_g_b_O_cObj: {},
	b_d_g_b_O_c1: [],

	raycaster: new THREE.Raycaster(),

	b_m_i_w: "",
	b_m_x_w: "",
	b_m_i_h: "",
	b_m_x_h: "",
	b_m_i_l: "",
	b_m_x_l: "",
	b_m_x_lC: "",
	b_m_i_hlean: "",
	arrayendLengthRoof: [],
	BuildingMinWidth: [],
	b_c_h_I_g: false,
	b_I_g_n_e: "building-normal.jpg",
	b_r_g_v: "",
	b_f_w_C: false,
	b_f_w_B: false,
	vVal: -0.03,
	sum: 1,
	b_r_d_V: "",
	leanto: [],
	b_o_J_1: {},
	b_f_o_J: {},
	post_data: {},
	entry_points: [],
	CheckDoorForEdit: false,
	b_l_o_J: {},
	Map_Id: {},
	defaultBuildingImgName: "",
	bTypeJson: {
		Garages: {
			door: { Size: [{ size: "8X8", wall: "fend", pos: { x: 0.47607825542070437, y: 0, z: 0 }, TrimKit: false }] }
		},
		Triple_Wide_Garages: {
			door: {
				Size: [
					{ size: "8X8", wall: "fend", pos: { x: -6.010555550834087, y: 3.2, z: 0 }, TrimKit: false },
					{ size: "8X8", wall: "fend", pos: { x: 5.023228140694575, y: 3.2, z: 0 }, TrimKit: false }
				]
			}
		},
		Raised_Center_Barns: {
			door: { Size: [{ size: "10X8", wall: "fend", pos: { x: 0.47607825542070437, y: 0, z: 0 }, TrimKit: false }] }
		},
		Utility_Buildings: {
			door: { Size: [{ size: "10X8", wall: "fend", pos: { x: 0.42771661532304966, y: 0, z: 11 }, TrimKit: false }] }
		},
		Commercial_Buildings: {
			door: { Size: [{ size: "10X8", wall: "fend", pos: { x: 0.47607825542070437, y: 0, z: 0 }, TrimKit: false }] }
		},
		Free_Standing_Buildings: {
			door: {
				Size: [
					{ size: "8X8", wall: "rside", pos: { x: -6.010555550834087, y: 3.2, z: 0 }, TrimKit: false },
					{ size: "8X8", wall: "rside", pos: { x: 5.023228140694575, y: 3.2, z: 0 }, TrimKit: false }
				]
			}
		}
	},
	TypeAlingnment: {
		1: "center",
		2: "front",
		3: "back",
		4: "custom"
	},
	endLeanAlingnmentType: {
		1: "center",
		2: "Left",
		3: "Right",
		4: "custom"
	},
	endLeanAlingnmentTypeReverse: {
		center: 1,
		Left: 2,
		Right: 3,
		custom: 4
	},
	TypeAlingnmentReverse: {
		center: 1,
		front: 2,
		back: 3,
		custom: 4
	},
	TypeWallName: {
		open: "Opened",
		close: "Closed",
		gable: "Gable",
		extended_gable: "Extended Gable",
		one_fourth_close: "1/4 Closed",
		three_fourth_close: "3/4 Closed",
		half_close: "1/2 Closed",
		"half dutch end": "Half Dutch End",
		"half end": "Half End"
	},
	TypeWallNameForEdit: {
		open: "Open",
		close: "Close",
		gable: "Gable",
		extended_gable: "Extended Gable",
		one_fourth_close: "One_Fourth_Close",
		three_fourth_close: "Three_Fourth_Close",
		half_close: "Half_Close",
		"half dutch end": "Half Dutch End",
		"half end": "Half End"
	},
	TypeEnum: {
		1: "Regular",
		2: "A-frame",
		3: "Vertical",
		8: "Regular",
		4: "Vertical",
		5: "A-frame",
		6: "Vertical",
		7: "A-frame"
	},
	TypeEnumForRoofChange: {
		1: 0,
		2: 1,
		3: 2
	},
	TypeEnumID: {
		1: "Regular",
		2: "A-frame",
		3: "Vertical",
		8: "Regular Roof Barn",
		4: "Raised Center Vertical",
		5: "Raised Center",
		6: "Continous Roof Vertical",
		7: "Continous Roof"
	},
	TypeEnumINDEX: {
		1: "0",
		2: "1",
		3: "2",
		8: "4",
		4: "0",
		5: "1",
		6: "2",
		7: "3"
	},
	WallClass: {
		front: "fend",
		back: "bend",
		left: "lside",
		right: "rside"
	},

	WallClassEdit: {
		fend: "front",
		bend: "back",
		lside: "left",
		rside: "right"
	},
	installationValue: {
		1: "Concrete",
		2: "Asphalt",
		3: "Ground",
		4: "Gravel"
	},
	// r_f_p_w_arr: [5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40],
	r_f_p_w_arr: [],
	l_f_p_w_arr: [],
	r_b_p_w_arr: [],
	l_b_p_w_arr: [],
	r_f_p_d_arr: [],
	r_b_p_d_arr: [],
	l_f_p_d_arr: [],
	l_b_p_d_arr: [],
	b_u_D_p_a7: [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40],
	b_u_D_p_a6: [
		3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57,
		58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100
	],
	b_u_D_p_a5: [5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90],
	b_u_D_p_a4: [4, 8, 12, 16, 20, 24, 28, 32, 36, 40, 44, 48, 52, 56, 60, 64, 68, 72, 76, 80, 84, 88],
	b_u_D_p_a: [
		5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95, 100, 105, 110, 115, 120, 125, 130, 135, 140, 145, 150, 155, 160, 165, 170, 175, 180, 185, 190, 195, 200, 205, 210, 215, 220, 225, 230,
		235.24, 245, 250, 255, 260, 265, 270, 275, 280, 285, 290, 295, 300
	],
	b_u_D_p_a_c_b: [
		3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57,
		58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100
	],
	b_u_D_p_a_c_b_l: [
		3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57,
		58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100
	],
	leantoleft: {
		alignment: "center",
		back_wall: "open",
		back_wall_price: 0,
		back_wall_vertical: false,
		basic_price: 0,
		continous_lean: false,
		front_wall: "open",
		front_wall_price: 0,
		front_wall_vertical: false,
		height: 8,
		height_price: 0,
		leanto_drop: null,
		leanto_type: 1,
		length: 31,
		pricing_data: "",
		roof_pitch: "3/12",
		roof_pitch_name: "3/12",
		roof_pitch_price: 0,
		side_wall: "open",
		side_wall_price: 0,
		side_wall_vertical: false,
		width: 12
	},
	leantoright: {
		alignment: "center",
		back_wall: "open",
		back_wall_price: 0,
		back_wall_vertical: false,
		basic_price: 0,
		continous_lean: false,
		front_wall: "open",
		front_wall_price: 0,
		front_wall_vertical: false,
		height: 8,
		height_price: 0,
		leanto_drop: null,
		leanto_type: 2,
		length: 31,
		pricing_data: "",
		roof_pitch: "3/12",
		roof_pitch_name: "3/12",
		roof_pitch_price: 0,
		side_wall: "open",
		side_wall_price: 0,
		side_wall_vertical: false,
		width: 12
	},
	b_M_g_V: 0.02,
	defaultProData: "",
	cutPanleLeftCheckL: true,
	cutPanleLeftCheckR: true,
	b_n_B_d: "",
	b_t_x_P_g: [],
	c_h_L_I_g: "",
	c_h_L_I_g1: "",
	s_L_d_C_k: 0,
	c_h_k_I_g_U_d: "",
	c_h_k_S_l_d: false,
	i_g_A_y: [],
	displayerrorMessage: {},
	c_h_L_d_V: true,
	d_r_a_m_l: {},
	c_h_d_M_l: false,
	checkFVL: "",
	checkFVR: "",
	H_d_l_D_r_ar: { front: [], back: [] },
	c_k_Do_po_s: "",
	c_k_C_n_s: false,
	I_g_m_ar_R: {},
	main_posGet: "",
	chkPrmVl: "",
	chkTabbedVal: "",
	chkModValByTab: false,
	drop_arr: {},
	d_w_a_r_N_w: [],
	colorTable: {},
	g_d_a_pD: [],
	CallApionAction: false,
	isPriceAPIcalled: false,
	place_d: false,
	chk_place: true,
	cmpObj_place: true,
	legstype: "single",
	leanLegstype: "single",
	leanFLegstype: "single",
	leanRLegstype: "single",
	leanBLegstype: "single",
	insulationJson: [],
	insulationPriceJson: [],
	insulationArrayForLeantoLeft: [],
	insulationArrayForLeantoFront: [],
	insulationArrayForLeantoBack: [],
	insulationArrayForLeantoRight: [],
	insulationPriceJsonCompare: [],
	insulationArrayForLeantoLeftCompare: {},
	insulationArrayForLeantoFrontCompare: {},
	insulationArrayForLeantoBackCompare: {},
	insulationArrayForLeantoRightCompare: {},
	compareInsulationForMainBuilding: {},
	compareInsulationForRightLeanto: {},
	compareInsulationForLefttLeanto: {},
	compareInsulationForFrontLeanto: {},
	compareInsulationForBacktLeanto: {},
	colorTableNext: {},
	MainuId: "",
	makeArrayForComponent: [],
	makeArrayForComponent_Barn: [],
	makeArrayForComponent_BarnR: [],
	Manidata: [
		{ id: 1, name: "Alabama", manufacturer_id: 8 },
		{ id: 2, name: "Arizona", manufacturer_id: 4 },
		{ id: 3, name: "Arkansas", manufacturer_id: 11 },
		{ id: 4, name: "California", manufacturer_id: 6 },
		{ id: 5, name: "Colorado", manufacturer_id: 11 },
		{ id: 6, name: "Connecticut", manufacturer_id: 8 },
		{ id: 7, name: "Delaware", manufacturer_id: 8 },
		{ id: 8, name: "Florida", manufacturer_id: 3 },
		{ id: 9, name: "Georgia", manufacturer_id: 8 },
		{ id: 10, name: "Idaho", manufacturer_id: 11 },
		{ id: 11, name: "Illinois", manufacturer_id: 11 },
		{ id: 12, name: "Indiana", manufacturer_id: 7 },
		{ id: 13, name: "Iowa", manufacturer_id: 4 },
		{ id: 14, name: "Kansas", manufacturer_id: 11 },
		{ id: 15, name: "Kentucky", manufacturer_id: 8 },
		{ id: 16, name: "Louisiana", manufacturer_id: 9 },
		{ id: 17, name: "Maryland", manufacturer_id: 8 },
		{ id: 18, name: "Massachusetts", manufacturer_id: 8 },
		{ id: 19, name: "Michigan", manufacturer_id: 7 },
		{ id: 20, name: "Minnesota", manufacturer_id: 4 },
		{ id: 21, name: "Mississippi", manufacturer_id: 11 },
		{ id: 22, name: "Missouri", manufacturer_id: 11 },
		{ id: 23, name: "Montana", manufacturer_id: 11 },
		{ id: 24, name: "Nebraska", manufacturer_id: 11 },
		{ id: 25, name: "Nevada", manufacturer_id: 11 },
		{ id: 26, name: "New Jersey", manufacturer_id: 8 },
		{ id: 27, name: "New Mexico", manufacturer_id: 11 },
		{ id: 28, name: "New York", manufacturer_id: 8 },
		{ id: 29, name: "North Carolina", manufacturer_id: 8 },
		{ id: 30, name: "North Dakota", manufacturer_id: 8 },
		{ id: 31, name: "Ohio", manufacturer_id: 8 },
		{ id: 32, name: "Oklahoma", manufacturer_id: 11 },
		{ id: 33, name: "Oregon", manufacturer_id: 11 },
		{ id: 34, name: "Pennsylvania", manufacturer_id: 8 },
		{ id: 35, name: "South Carolina", manufacturer_id: 8 },
		{ id: 36, name: "South Dakota", manufacturer_id: 8 },
		{ id: 37, name: "Tennessee", manufacturer_id: 8 },
		{ id: 38, name: "Texas", manufacturer_id: 9 },
		{ id: 39, name: "Utah", manufacturer_id: 11 },
		{ id: 40, name: "Virginia", manufacturer_id: 8 },
		{ id: 41, name: "West Virginia", manufacturer_id: 8 },
		{ id: 42, name: "Wisconsin", manufacturer_id: 4 },
		{ id: 43, name: "Wyoming", manufacturer_id: 11 },
		{ id: 44, name: "Washington", manufacturer_id: 8 },
		{ id: 45, name: "Maine", manufacturer_id: 8 },
		{ id: 46, name: "New Hampshire", manufacturer_id: 8 },
		{ id: 47, name: "Rhode Island", manufacturer_id: 8 },
		{ id: 48, name: "Vermont", manufacturer_id: 8 }
	],
	checkFunCalling: false,
	DiscountData: "",
	Heading: "",
	newComponentArray: {},
	CustomDoorArr: {
		Garage: {
			Size: {},
			Object: {},
			SidePrice: {},
			EndPrice: {},
			TrimKit: {},
			Chain_Hoist: {},
			Header_Seal: {},
			Is_Chain_Hoist: {},
			Is_Header_Seal: {},
			Is_Certified: {},
			Certified_Cost: {},
			Is_Automatic_Openers: {},
			Automatic_Openers_Cost: {},
			garageDoorColor: {}
		},
		sectionalGarage: { Size: {}, Object: {}, SidePrice: {}, EndPrice: {}, TrimKit: {}, Chain_Hoist: {}, Header_Seal: {} },
		Walk: { Size: {}, Object: {}, SidePrice: {}, EndPrice: {} },
		WalkFrameout: { Size: {}, Object: {}, SidePrice: {}, EndPrice: {} },
		Windows: { Size: {}, Object: {}, SidePrice: {}, EndPrice: {} },
		WindowsFrameout: { Size: {}, Object: {}, SidePrice: {}, EndPrice: {} },
		GarageFrameout: { Size: {}, Object: {}, SidePrice: {}, EndPrice: {}, TrimKit: {} },
		CustomFrameout: { Size: {}, Object: {}, SidePrice: {}, EndPrice: {}, TrimKit: {}, Width: {}, Height: {} }
	},
	CustomDoorArrForOtherBtype: {},
	ManageDoorWallVal: {
		front: "Front",
		back: "Back",
		left: "Left",
		right: "Right",
		Ltleft: "Left Leanto Left",
		Ltright: "Right Leanto Right",
		FrontL: "Left Leanto Front",
		FrontR: "Right Leanto Front",
		BackL: "Left Leanto Back",
		BackR: "Right Leanto Back",
		LeftS: "Left Leanto Utility Front",
		RightS: "Right Leanto Utility Front",
		BarnRight: "Right Leanto Right",
		BarnLeft: "Left Leanto Left"
	},
	ManageDoorArrar: {
		front: [],
		back: [],
		left: [],
		right: [],
		ltleft: [],
		ltright: [],
		ltfront: [],
		ltback: [],
		frontl: [],
		frontr: [],
		leftf: [],
		backl: [],
		backr: [],
		rightf: [],
		lefts: [],
		rights: [],
		fronts: [],
		backs: []
	},
	ManageGlobalComponent: {
		front: [],
		back: [],
		left: [],
		right: [],
		ltleft: [],
		ltright: [],
		ltfront: [],
		ltback: [],
		frontl: [],
		frontr: [],
		leftf: [],
		backl: [],
		backr: [],
		rightf: [],
		lefts: [],
		rights: [],
		fronts: [],
		backs: []
	},
	ManageSpaces: [],
	ManageDoorPlaces: {
		front: { Garage: true, CustomFrameout: true, Walk: true, WalkFrameout: true, Windows: true, WindowsFrameout: true, GarageFrameout: true },
		back: { Garage: true, CustomFrameout: true, Walk: true, WalkFrameout: true, Windows: true, WindowsFrameout: true, GarageFrameout: true },
		left: { Garage: true, CustomFrameout: true, Walk: true, WalkFrameout: true, Windows: true, WindowsFrameout: true, GarageFrameout: true },
		right: { Garage: true, CustomFrameout: true, Walk: true, WalkFrameout: true, Windows: true, WindowsFrameout: true, GarageFrameout: true },
		ltleft: { Garage: true, CustomFrameout: true, Walk: true, WalkFrameout: true, Windows: true, WindowsFrameout: true, GarageFrameout: true },
		ltright: { Garage: true, CustomFrameout: true, Walk: true, WalkFrameout: true, Windows: true, WindowsFrameout: true, GarageFrameout: true },
		frontl: { Garage: true, CustomFrameout: true, Walk: true, WalkFrameout: true, Windows: true, WindowsFrameout: true, GarageFrameout: true },
		frontr: { Garage: true, CustomFrameout: true, Walk: true, WalkFrameout: true, Windows: true, WindowsFrameout: true, GarageFrameout: true },
		backl: { Garage: true, CustomFrameout: true, Walk: true, WalkFrameout: true, Windows: true, WindowsFrameout: true, GarageFrameout: true },
		backr: { Garage: true, CustomFrameout: true, Walk: true, WalkFrameout: true, Windows: true, WindowsFrameout: true, GarageFrameout: true },
		lefts: { Garage: true, CustomFrameout: true, Walk: true, WalkFrameout: true, Windows: true, WindowsFrameout: true, GarageFrameout: true },
		rights: { Garage: true, CustomFrameout: true, Walk: true, WalkFrameout: true, Windows: true, WindowsFrameout: true, GarageFrameout: true },
		fronts: { Garage: true, CustomFrameout: true, Walk: true, WalkFrameout: true, Windows: true, WindowsFrameout: true, GarageFrameout: true }
	},
	persistWallVal: { front: "Open", back: "Open", left: "Open", right: "Open", cutpanel_Left: false, cutpanel_Right: false, AllWall: false, Utility: false },
	lightUpdate: "",
	PointLight11: "",
	PointLight111: "",
	PointLight: "",
	PointLight1: "",
	textureUrl: "",
	textureLoader: "",
	textureWidth: "",
	textureWidthLeft: "",
	textureWidthRight: "",
	textureDepth: "",
	textureHalfTruss1Width: "",
	textureHalfTruss1Depth: "",
	textureHalfTruss2Width: "",
	textureHalfTruss2Depth: "",
	textureHalfTruss3Width: "",
	textureHalfTruss3Depth: "",
	textureHalfTruss4Width: "",
	textureHalfTruss4Depth: "",
	isShowAlert: false,
	isShowCompare: false,
	alertUsedFor: "",
	selectedTabKeyForWheel: "statechange",
	stateHelpTextContent: false,
	colorsHelpTextContent: false,
	buildSizeHelpTextContent: false,
	leantoHelpTextContent: false,
	wallsHelpTextContent: false,
	doorWindowHelpTextContent: false,
	extraHelpTextContent: false,
	isHalfEnclosedChecked: false,
	isHalfEnclosedCheckedVal: "",
	isShowbuildingtype: false,
	isShowbuildingtypeArr: [],
	colorTable: {
		CardinalRed: "0x9c132e",
		TrueBurgundy: "0x7a2527",
		PebbleBeige: "0xd9dabb",
		Clay: "0xccc7c0",
		EarthBrown: "0x4e3227",
		Evergreen: "0x274e37",
		Black: "0x212121",
		Gray: "0x8c8d8e",
		QuakerGray: "0x575a5d",
		Sandstone: "0xd2d0b5",
		SlateBlue: "0x44687d",
		Tan: "0xbe9272",
		White: "0xffffff",
		BarnRed: "0xa63f1e",
		VintageBurgundy: "0x5a2c34",
		KingBlue: "0x3380b8"
	},
	/* APi Manager Constant */
	BASE_URL: "https://pricing.senseicrm.com:3006/api/",
	GET_BUILDING_APi: "getBuildingData",
	GET_PRICEING_APi: "getBuildingPricing",
	order_extra_items: {
		job_site_level: "",
		inside_city: "",
		installation_ready: "",
		surface_level: "",
		electricity: "",
		welded_spacer: "",
		notched_lip: "",
		space_around_building: "",
		site_clear_obstacle: "",
		permit: params.m_s_n == 67 ? "cust_verify" : "yes",
		order_permit_fee: 0,
		includeIn: "",
		equipment_rental: 0,
		document_fee: 0,
		order_processing_fee: 0,
		surchargeFees: 0,
		delivery_fee: 0,
		engineer_drawings: 0,
		freight: 0,
		extra_labour: 0,
		labor_fee_on: null,
		labor_per_type: 0,
		processing_fee: 0,
		grvy_value: 0,
		has_grvy: 0,
		concrete_work: 0,
		ground_work: 0,
		pdf_price_breakdown: "0",
		dont_show_processing_fee_pdf: 1,
		engineer_drawings_name: "" //{'name': 'None', 'cost': 0},
	},
	moveBoxName: "",
	showComponentDeleteAlert: false,
	isFrontLeanFront: false,
	isFrontLeanRight: false,
	isFrontLeanLeft: false,
	isBackLeanFront: false,
	isBackLeanRight: false,
	isBackLeanLeft: false,
	isLeftLeanFront: false,
	isLeftLeanBack: false,
	isLeftLeanLeft: false,
	isCenterFront: false,
	isCenterBack: false,
	isCenterRight: false,
	isCenterLeft: false,
	isRightLeanFront: false,
	isRightLeanBack: false,
	isRightLeanRight: false,
	componentNameForAlert: "",

	isDealerDiscountBannerVisible: false,
	// 2d layout
	layout2DMapId: 0,
	generated2DMapId: null,
	showLoginScreen: window.showLoginScreen != undefined ? window.showLoginScreen : false,
	componentData: {}
};

export const kFront = "front";
export const kBack = "back";
export const kLeft = "left";
export const kRight = "right";
export const kLeftCutPanel = "leftCutPanel";
export const kRightCutPanel = "rightCutPanel";
export const kFronttCutPanel = "frontCutPanel";
export const kBackCutPanel = "backCutPanel";
export const kYES = "YES";
export const kNO = "NO";
